import React, { useState, useEffect } from 'react';
// Removed framer-motion animations
import { db } from '../firebase';
import '../styles/homeQuietLounge.css';
import { collection, query, where, orderBy, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, onSnapshot, writeBatch } from 'firebase/firestore';
import { User } from 'firebase/auth';
import PageHeader from './ui/PageHeader';
import AIMatchmaking from './AIMatchmaking';
import PartnerConnect from './PartnerConnect';
// import ConnectionRequests from './ConnectionRequests';
import ConnectieFlow from './ConnectieFlow';
import ChatInterface from './ChatInterface';
import OpenForConnectionsList from './OpenForConnectionsList';
import WorkScopeSettings from './WorkScopeSettings';
import { getValidProfilePhoto } from '../utils/profileUtils';
import { UserProfile } from '../types';
// AdminMuteButton removed - only used for posts now
import { AdminMutePanel } from './admin/AdminMutePanel';
// import { ProfileCardSkeleton, PostCardSkeleton } from './ui/SkeletonLoader';
import { openChat } from '../utils/navigationHelper';
import { canSeePlatformOnlineStats } from '../utils/platformAdmin';
import { PartnerIcon, ChatIcon } from './icons';
import { RefreshCw, Star, Search, AlertTriangle } from 'lucide-react';
import { ArchiveTray, Handshake } from 'phosphor-react';



interface ConnectionRequest {
  knownContact?: {
    markedBy: string;
    markedAt: any;
    status: 'pending' | 'direct_connect' | 'declined' | 'continue';
  };
  id: string;
  fromUserId: string;
  toUserId: string;
  fromUserName: string;
  toUserName: string;
  fromUserPhoto?: string;
  message?: string;
  status: 'pending' | 'accepted' | 'declined';
  createdAt: Date;
  updatedAt: Date;
}

interface Connection {
  id: string;
  user1Id: string;
  user2Id: string;
  user1Name: string;
  user2Name: string;
  user1Photo?: string;
  user2Photo?: string;
  createdAt: Date;
  lastChatAt?: Date;
  chatCount: number;
}

interface ConnectiesPageProps {
  userProfile: UserProfile | null;
  mobileTabIndex?: number;
}

const ConnectiesPage: React.FC<ConnectiesPageProps> = ({ userProfile, mobileTabIndex = 0 }) => {
  const [activeTab, setActiveTab] = useState<'chatflow' | 'all' | 'connections' | 'requests' | 'sent' | 'ai-matching' | 'partner-connect' | 'chat-interface' | 'verbinden-met' | 'open-for-connections' | 'matchmaking'>('open-for-connections');
  const [allMembers, setAllMembers] = useState<UserProfile[]>([]);
  const [connections, setConnections] = useState<Connection[]>([]);
  const [incomingRequests, setIncomingRequests] = useState<ConnectionRequest[]>([]);
  const [sentRequests, setSentRequests] = useState<ConnectionRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMember, setSelectedMember] = useState<UserProfile | null>(null);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestMessage, setRequestMessage] = useState('');
  const [isKnownContact, setIsKnownContact] = useState(false);
  const [processingDirectConnect, setProcessingDirectConnect] = useState<string | null>(null);
  const [onlineUsers, setOnlineUsers] = useState<number>(0);
  const [communityProfiles, setCommunityProfiles] = useState<UserProfile[]>([]);
  const [posts7dByUser, setPosts7dByUser] = useState<Record<string, number>>({});
  const [msgs7dByUser, setMsgs7dByUser] = useState<Record<string, number>>({});
  const [inviteOpen, setInviteOpen] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  // const [inviteMessage, setInviteMessage] = useState('');
  const [selfProfileDoc, setSelfProfileDoc] = useState<UserProfile | null>(null);
  // Email invite templates
  const defaultInviteSubject = 'Uitnodiging voor SuperKonnected community';
  const buildDefaultInviteBody = () => (
    'Beste {{name}},\n\n' +
    'Ik nodig je uit om lid te worden van onze community.\n\n' +
    'Met vriendelijke groet,\n' +
    '{{profile_signature}}'
  );
  const [inviteTemplates, setInviteTemplates] = useState<{ id: string; name: string; subject: string; body: string }[]>([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>('default');
  const [templateName, setTemplateName] = useState<string>('Standaard');
  const [templateSubject, setTemplateSubject] = useState<string>(defaultInviteSubject);
  const [templateBody, setTemplateBody] = useState<string>(buildDefaultInviteBody());
  const [regionalUsers, setRegionalUsers] = useState<UserProfile[]>([]);
  const [loadingRegionalUsers, setLoadingRegionalUsers] = useState(false);
  const [showWorkScopeSettings, setShowWorkScopeSettings] = useState(false);
  const [showRegionOptions, setShowRegionOptions] = useState(true);
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
  const [inviteRecipientName, setInviteRecipientName] = useState<string>('');
  const [openCard, setOpenCard] = useState<'discover' | 'connections' | 'display' | 'community' | 'chatflow'>('chatflow');
  const [showCleanConfirm, setShowCleanConfirm] = useState(false);

  const toggleCard = (key: 'discover' | 'connections' | 'display' | 'community' | 'chatflow') => {
    // Keep exactly one card open; clicking the same card keeps it open
    setOpenCard(prev => (prev === key ? prev : key));
  };

  // Clean all connections function - for testing purposes
  // Wist ALLE connecties zodat personen weer gevonden kunnen worden via regio/werk regio
  const handleCleanAllConnections = async () => {
    if (!userProfile?.uid) {
      alert('Je moet ingelogd zijn om deze functie te gebruiken.');
      return;
    }

    try {
      console.log('🧹 Starting clean operation - deleting ALL connections...');
      
      let deletedRequests = 0;
      let deletedConnections = 0;
      let deletedChatRooms = 0;
      let deletedFlows = 0;
      let deletedMessages = 0;

      // 1. Delete ALL connection requests
      const requestsQuery = query(collection(db, 'connectionRequests'));
      const requestsSnapshot = await getDocs(requestsQuery);
      const batchSize = 500; // Firestore batch limit
      let currentBatch = writeBatch(db);
      let batchCount = 0;
      
      for (let i = 0; i < requestsSnapshot.docs.length; i++) {
        const doc = requestsSnapshot.docs[i];
        currentBatch.delete(doc.ref);
        batchCount++;
        deletedRequests++;
        
        // Commit and create new batch if we reach the limit
        if (batchCount >= batchSize) {
          await currentBatch.commit();
          console.log(`✅ Committed batch of ${batchCount} connection requests`);
          currentBatch = writeBatch(db);
          batchCount = 0;
        }
      }
      
      if (batchCount > 0) {
        await currentBatch.commit();
        console.log(`✅ Deleted ${deletedRequests} connection requests total`);
      }

      // 2. Delete ALL connections
      const connectionsQuery = query(collection(db, 'connections'));
      const connectionsSnapshot = await getDocs(connectionsQuery);
      currentBatch = writeBatch(db);
      batchCount = 0;
      
      for (let i = 0; i < connectionsSnapshot.docs.length; i++) {
        const doc = connectionsSnapshot.docs[i];
        currentBatch.delete(doc.ref);
        batchCount++;
        deletedConnections++;
        
        if (batchCount >= batchSize) {
          await currentBatch.commit();
          console.log(`✅ Committed batch of ${batchCount} connections`);
          currentBatch = writeBatch(db);
          batchCount = 0;
        }
      }
      
      if (batchCount > 0) {
        await currentBatch.commit();
        console.log(`✅ Deleted ${deletedConnections} connections total`);
      }

      // 3. Delete ALL chat rooms and their messages
      const chatRoomsQuery = query(collection(db, 'chatRooms'));
      const chatRoomsSnapshot = await getDocs(chatRoomsQuery);
      
      for (const roomDoc of chatRoomsSnapshot.docs) {
        // Delete messages in this chat room
        const messagesQuery = query(
          collection(db, 'chatMessages'),
          where('chatRoomId', '==', roomDoc.id)
        );
        const messagesSnapshot = await getDocs(messagesQuery);
        let messageBatch = writeBatch(db);
        let messageBatchCount = 0;
        
        for (let i = 0; i < messagesSnapshot.docs.length; i++) {
          const msgDoc = messagesSnapshot.docs[i];
          messageBatch.delete(msgDoc.ref);
          messageBatchCount++;
          deletedMessages++;
          
          if (messageBatchCount >= batchSize) {
            await messageBatch.commit();
            console.log(`✅ Committed batch of ${messageBatchCount} messages`);
            messageBatch = writeBatch(db);
            messageBatchCount = 0;
          }
        }
        
        if (messageBatchCount > 0) {
          await messageBatch.commit();
          console.log(`✅ Deleted ${messagesSnapshot.docs.length} messages for room ${roomDoc.id}`);
        }
        
        // Delete the chat room
        await deleteDoc(roomDoc.ref);
        deletedChatRooms++;
        console.log(`✅ Deleted chat room ${roomDoc.id}`);
      }

      // 4. Delete ALL connection flows and their subcollections
      const flowsQuery = query(collection(db, 'connectionFlows'));
      const flowsSnapshot = await getDocs(flowsQuery);
      
      for (const flowDoc of flowsSnapshot.docs) {
        // Delete messages in connection flow
        const flowMessagesQuery = query(
          collection(db, 'connectionFlows', flowDoc.id, 'messages')
        );
        const flowMessagesSnapshot = await getDocs(flowMessagesQuery);
        const batchFlowMessages = writeBatch(db);
        flowMessagesSnapshot.docs.forEach(msgDoc => {
          batchFlowMessages.delete(msgDoc.ref);
          deletedMessages++;
        });
        await batchFlowMessages.commit();
        
        // Delete time slots in connection flow
        const timeSlotsQuery = query(
          collection(db, 'connectionFlows', flowDoc.id, 'timeSlots')
        );
        const timeSlotsSnapshot = await getDocs(timeSlotsQuery);
        const batchTimeSlots = writeBatch(db);
        timeSlotsSnapshot.docs.forEach(slotDoc => {
          batchTimeSlots.delete(slotDoc.ref);
        });
        await batchTimeSlots.commit();
        
        // Delete the flow
        await deleteDoc(flowDoc.ref);
        deletedFlows++;
        console.log(`✅ Deleted connection flow ${flowDoc.id}`);
      }

      // Refresh the UI
      setConnections([]);
      setIncomingRequests([]);
      setSentRequests([]);
      loadEssentialData();

      alert(`✅ Clean voltooid!\n\n` +
        `- ${deletedRequests} connection requests verwijderd\n` +
        `- ${deletedConnections} connections verwijderd\n` +
        `- ${deletedChatRooms} chat rooms verwijderd\n` +
        `- ${deletedFlows} connection flows verwijderd\n` +
        `- ${deletedMessages} berichten verwijderd\n\n` +
        `Alle connecties zijn gewist. Personen kunnen nu weer gevonden worden via regio/werk regio synchronisatie.`);
      
      console.log('✅ Clean operation completed successfully');
    } catch (error) {
      console.error('❌ Error during clean operation:', error);
      alert('Fout bij het wissen van connecties: ' + (error as Error).message);
    }
  };

  // ✅ NEW: Reset ONLY my own connection requests (safe test-reset)
  const handleResetMyConnectionRequests = async () => {
    if (!userProfile?.uid) {
      alert('Je moet ingelogd zijn om deze functie te gebruiken.');
      return;
    }

    try {
      const currentUserId = userProfile.uid;
      console.log('🧹 Resetting connection requests for current user:', currentUserId);

      // Haal alle verzoeken op waar deze gebruiker bij betrokken is
      const requestsRef = collection(db, 'connectionRequests');

      const [fromSnap, toSnap, senderSnap, receiverSnap] = await Promise.all([
        getDocs(query(requestsRef, where('fromUserId', '==', currentUserId))),
        getDocs(query(requestsRef, where('toUserId', '==', currentUserId))),
        // Legacy velden
        getDocs(query(requestsRef, where('senderId', '==', currentUserId))),
        getDocs(query(requestsRef, where('receiverId', '==', currentUserId)))
      ]);

      // Combineer alle docs en dedupliqueer op id
      const allDocs = [
        ...fromSnap.docs,
        ...toSnap.docs,
        ...senderSnap.docs,
        ...receiverSnap.docs
      ];

      const uniqueDocsMap = new Map<string, typeof allDocs[number]>();
      allDocs.forEach(docSnap => {
        if (!uniqueDocsMap.has(docSnap.id)) {
          uniqueDocsMap.set(docSnap.id, docSnap);
        }
      });

      const uniqueDocs = Array.from(uniqueDocsMap.values());

      if (uniqueDocs.length === 0) {
        alert('Er zijn geen connectieverzoeken gevonden die aan jouw account gekoppeld zijn.');
        return;
      }

      let batch = writeBatch(db);
      let batchCount = 0;
      let deletedRequests = 0;
      const batchSize = 500;

      for (const docSnap of uniqueDocs) {
        batch.delete(docSnap.ref);
        batchCount++;
        deletedRequests++;

        if (batchCount >= batchSize) {
          await batch.commit();
          console.log(`✅ Committed batch of ${batchCount} connection requests for current user`);
          batch = writeBatch(db);
          batchCount = 0;
        }
      }

      if (batchCount > 0) {
        await batch.commit();
      }

      console.log(`✅ Reset ${deletedRequests} connection requests for user ${currentUserId}`);

      // Refresh UI state
      await loadEssentialData();

      alert(`✅ ${deletedRequests} connectieverzoeken gekoppeld aan jouw account zijn verwijderd.\n\n` +
        'Je kunt nu opnieuw testen door nieuwe verzoeken te sturen.');
    } catch (error) {
      console.error('❌ Error resetting connection requests for current user:', error);
      alert('Fout bij het resetten van jouw connectieverzoeken: ' + (error as Error).message);
    }
  };

  const handleRegionToggle = (region: string) => {
    setSelectedRegions(prev => {
      const newRegions = prev.includes(region) 
        ? prev.filter(r => r !== region)
        : [...prev, region];
      
      // Automatically save to user profile
      saveRegionPreferences(newRegions);
      
      return newRegions;
    });
  };

  // Save selected regions to user profile
  const saveRegionPreferences = async (regions: string[]) => {
    if (!userProfile?.uid) return;
    
    try {
      const { doc, updateDoc } = await import('firebase/firestore');
      const userRef = doc(db, 'userProfiles', userProfile.uid);
      await updateDoc(userRef, {
        selectedRegions: regions,
        lastUpdated: new Date()
      });
      console.log('✅ Regio voorkeuren opgeslagen:', regions);
    } catch (error) {
      console.error('❌ Fout bij opslaan regio voorkeuren:', error);
    }
  };

  // ✅ FIX: Real-time listener for userProfiles (bidirectional sync with ProfileSettings)
  useEffect(() => {
    if (!userProfile?.uid) return;
    
    const userProfilesRef = doc(db, 'userProfiles', userProfile.uid);
    
    // Real-time listener for userProfiles changes (from ProfileSettings)
    const unsubscribe = onSnapshot(userProfilesRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.data();
        
        if (userData.selectedRegions) {
          setSelectedRegions(userData.selectedRegions);
        }
      }
    }, (error) => {
      console.error('❌ Error in ConnectiesPage real-time listener:', error);
    });
    
    return () => {
      unsubscribe();
    };
  }, [userProfile?.uid]);
  
  // Load initial region preferences from user profile
  const loadRegionPreferences = async () => {
    if (!userProfile?.uid) return;
    
    try {
      const { doc, getDoc } = await import('firebase/firestore');
      const userRef = doc(db, 'userProfiles', userProfile.uid);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        const userData = userSnap.data();
        if (userData.selectedRegions) {
          setSelectedRegions(userData.selectedRegions);
        }
      }
    } catch (error) {
      console.error('❌ Fout bij laden regio voorkeuren:', error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (userProfile?.uid) {
      loadEssentialData();
      loadRegionPreferences();
    }
  }, [userProfile]);

  // Listen for connection status changes
  useEffect(() => {
    const onConnectionStatusChange = () => {
      // Reload data when connection status changes
      if (userProfile?.uid) {
        loadEssentialData();
      }
    };

    window.addEventListener('connectionStatusChanged', onConnectionStatusChange);
    return () => window.removeEventListener('connectionStatusChanged', onConnectionStatusChange);
  }, [userProfile?.uid]);

  // Load regional users when "Verbinden met" tab is selected
  useEffect(() => {
    if (activeTab === 'verbinden-met') {
      loadRegionalUsers();
    }
  }, [activeTab, userProfile?.uid, connections, incomingRequests, sentRequests]);

  // Listen for switch to verbinden-met tab from ConnectieFlow
  useEffect(() => {
    const handleSwitchToVerbindenMet = () => {
      setActiveTab('verbinden-met');
    };

    window.addEventListener('switchToVerbindenMet', handleSwitchToVerbindenMet);
    return () => window.removeEventListener('switchToVerbindenMet', handleSwitchToVerbindenMet);
  }, []);

  // Listen for opening a specific connection in ConnectieFlow (triggered from global popup)
  useEffect(() => {
    const handler = (event: any) => {
      try {
        console.log('📥 ConnectiesPage received openConnectionFlowForConnection event', event.detail);
        const detail = event.detail || {};
        const connectionId = detail.connectionId as string | undefined;
        const mode = detail.mode as 'chat' | 'agenda' | undefined;
        if (!connectionId) {
          console.warn('⚠️ No connectionId in event detail');
          return;
        }

        console.log('🔄 Setting activeTab to chatflow');
        setActiveTab('chatflow');

        // Delay to ensure ConnectieFlow is rendered before event bubbles further
        setTimeout(() => {
          console.log('📢 Dispatching selectConnectionInFlow with:', { connectionId, mode });
          window.dispatchEvent(
            new CustomEvent('selectConnectionInFlow', {
              detail: { connectionId, mode }
            })
          );
        }, 200);
      } catch (e) {
        console.error('❌ Error handling openConnectionFlowForConnection event', e);
      }
    };

    window.addEventListener('openConnectionFlowForConnection', handler as any);
    return () => window.removeEventListener('openConnectionFlowForConnection', handler as any);
  }, []);

  // Listen for external request to open ConnectionFlow (from Netwerk accept popup)
  useEffect(() => {
    const handleOpenConnectionFlow = () => {
      setActiveTab('chatflow');
    };

    window.addEventListener('openConnectionFlow', handleOpenConnectionFlow as any);
    return () => window.removeEventListener('openConnectionFlow', handleOpenConnectionFlow as any);
  }, []);

  // Debug function to manually create connection
  const createTestConnection = async () => {
    if (!userProfile?.uid) {
      console.log('No user profile available');
      return;
    }
    
    try {
      console.log('All members:', allMembers);
      
      // Find Studio Antonio user - try multiple variations
      const studioAntonio = allMembers.find(m => {
        const name = m.displayName?.toLowerCase() || '';
        return name.includes('studio') || name.includes('antonio') || name.includes('antonio');
      });
      
      if (studioAntonio) {
        console.log('Found Studio Antonio:', studioAntonio);
        
        // Check if connection already exists
        const existingConnection = connections.find(c => 
          (c.user1Id === userProfile.uid && c.user2Id === studioAntonio.uid) ||
          (c.user2Id === userProfile.uid && c.user1Id === studioAntonio.uid)
        );
        
        if (existingConnection) {
          console.log('Connection already exists:', existingConnection);
          alert('Connectie met Studio Antonio bestaat al!');
          return;
        }
        
        // Create connection
        const connectionData = {
          user1Id: userProfile.uid,
          user2Id: studioAntonio.uid,
          user1Name: userProfile.displayName || 'Profile Business Security 28-BS28',
          user2Name: studioAntonio.displayName || 'Studio Antonio',
          user1Photo: userProfile.photoURL,
          user2Photo: studioAntonio.photoURL,
          createdAt: new Date(),
          chatCount: 0
        };
        
        console.log('Creating connection with data:', connectionData);
        const docRef = await addDoc(collection(db, 'connections'), connectionData);
        console.log('Connection created successfully with ID:', docRef.id);
        
        alert('Connectie met Studio Antonio is aangemaakt!');
        // Reload data
        await loadEssentialData();
      } else {
        console.log('Studio Antonio not found in members. Available members:', allMembers.map(m => m.displayName));
        alert('Studio Antonio niet gevonden in de ledenlijst. Check de console voor details.');
      }
    } catch (error) {
      console.error('Error creating test connection:', error);
      alert('Fout bij het maken van de connectie: ' + (error instanceof Error ? error.message : 'Onbekende fout'));
    }
  };

  const loadEssentialData = async () => {
    try {
      // Load only essential data first (connections and basic profile)
      const connectionsQuery = query(
        collection(db, 'connections'),
        where('user1Id', '==', userProfile?.uid)
      );
      const connectionsQuery2 = query(
        collection(db, 'connections'),
        where('user2Id', '==', userProfile?.uid)
      );
      const [connectionsSnapshot, connectionsSnapshot2] = await Promise.all([
        getDocs(connectionsQuery),
        getDocs(connectionsQuery2)
      ]);
      
      // Combine and deduplicate connections
      const allConnections = [...connectionsSnapshot.docs, ...connectionsSnapshot2.docs];
      const uniqueConnections = new Map();
      
      allConnections.forEach(doc => {
        const data = doc.data();
        const connectionId = doc.id;
        if (!uniqueConnections.has(connectionId)) {
          uniqueConnections.set(connectionId, {
            id: connectionId,
            user1Id: data.user1Id,
            user2Id: data.user2Id,
            user1Name: data.user1Name || 'Onbekend',
            user2Name: data.user2Name || 'Onbekend',
            user1Photo: data.user1Photo,
            user2Photo: data.user2Photo,
            createdAt: data.createdAt?.toDate() || new Date(),
            lastChatAt: data.lastChatAt?.toDate() || null,
            chatCount: data.chatCount || 0
          });
        }
      });
      
      const connectionsData = Array.from(uniqueConnections.values()) as Connection[];
      setConnections(connectionsData);
      setLoading(false); // Show page immediately after essential data
      
      // Load additional data in background
      loadAdditionalData();
      
    } catch (error) {
      console.error('Error loading essential data:', error);
      setLoading(false);
    }
  };

  // Check if two users should match based on work scope
  const shouldMatchUsers = (user1: any, user2: any) => {
    const user1Scope = user1.workScope || user1.onboardingData?.workScope || 'lokaal';
    const user2Scope = user2.workScope || user2.onboardingData?.workScope || 'lokaal';
    
    // If either user has international scope, they can match with anyone
    if (user1Scope === 'internationaal' || user2Scope === 'internationaal') {
      return true;
    }
    
    // If both have national scope, check if same country
    if (user1Scope === 'nationaal' && user2Scope === 'nationaal') {
      const user1Country = user1.workScopeCountry || user1.onboardingData?.workScopeCountry || user1.country;
      const user2Country = user2.workScopeCountry || user2.onboardingData?.workScopeCountry || user2.country;
      return user1Country === user2Country;
    }
    
    // If both have local scope, check if same region
    if (user1Scope === 'lokaal' && user2Scope === 'lokaal') {
      return user1.region === user2.region;
    }
    
    // Mixed scopes: national can match with local if same country
    if ((user1Scope === 'nationaal' && user2Scope === 'lokaal') || 
        (user1Scope === 'lokaal' && user2Scope === 'nationaal')) {
      const nationalUser = user1Scope === 'nationaal' ? user1 : user2;
      const localUser = user1Scope === 'lokaal' ? user1 : user2;
      const nationalCountry = nationalUser.workScopeCountry || nationalUser.onboardingData?.workScopeCountry || nationalUser.country;
      const localCountry = localUser.country;
      return nationalCountry === localCountry;
    }
    
    return false;
  };

  // Load regional users for "Verbinden met" tab
  const loadRegionalUsers = async () => {
    if (!userProfile?.uid) return;
    
    setLoadingRegionalUsers(true);
    try {
      // Get all users and filter in memory using flexible work scope matching
      const usersQuery = query(
        collection(db, 'userProfiles'),
        where('uid', '!=', userProfile.uid) // Exclude current user
      );
      
      const usersSnapshot = await getDocs(usersQuery);
      const allUsers = usersSnapshot.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      })) as UserProfile[];
      
      // Create current user object for matching
      const currentUserData = {
        workScope: (userProfile as any).workScope || (userProfile as any).onboardingData?.workScope || 'lokaal',
        region: (userProfile as any).region,
        country: (userProfile as any).country,
        workScopeCountry: (userProfile as any).workScopeCountry || (userProfile as any).onboardingData?.workScopeCountry
      };
      
      // Filter users based on work scope compatibility
      const compatibleUsers = allUsers.filter(user => {
        return shouldMatchUsers(currentUserData, user);
      });
      
      // Filter out users we already have connections with
      const connectedUserIds = new Set([
        ...connections.map(c => c.user1Id),
        ...incomingRequests.map(r => r.fromUserId),
        ...sentRequests.map(r => r.toUserId)
      ]);
      
      const availableUsers = compatibleUsers.filter(user => !connectedUserIds.has(user.uid));
      setRegionalUsers(availableUsers);
      
    } catch (error) {
      console.error('Error loading regional users:', error);
    } finally {
      setLoadingRegionalUsers(false);
    }
  };

  const loadAdditionalData = async () => {
    try {
      // Load all members in background
      const membersQuery = query(collection(db, 'userProfiles'), orderBy('lastActive', 'desc'));
      const membersSnapshot = await getDocs(membersQuery);
      const membersData = membersSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          uid: data.uid || doc.id,
          displayName: data.displayName || 'Onbekend',
          email: data.email || '',
          photoURL: data.photoURL,
          bio: data.bio,
          company: data.company,
          role: data.role,
          location: data.location,
          interests: data.interests || [],
          joinDate: data.joinedAt?.toDate() || new Date(),
          lastSeen: data.lastActive?.toDate() || new Date(),
          socialSharingEnabled: data.socialSharingEnabled || false,
          sharingFrequency: data.sharingFrequency || 3,
          totalShares: data.totalShares || 0,
          connectionStatus: data.connectionStatus || 'none',
          points: data.points || 0,
          isOnboarded: data.isOnboarded || false
        } as UserProfile;
      });
      
      // Filter out current user
      const filteredMembers = membersData.filter(member => member.uid !== userProfile?.uid);
      setAllMembers(filteredMembers);

      // Load incoming requests (support both legacy from/to and sender/receiver fields)
      const incomingQ1 = query(
        collection(db, 'connectionRequests'),
        where('toUserId', '==', userProfile?.uid),
        where('status', '==', 'pending')
      );
      const incomingQ2 = query(
        collection(db, 'connectionRequests'),
        where('receiverId', '==', userProfile?.uid),
        where('status', '==', 'pending')
      );
      const [incomingS1, incomingS2] = await Promise.all([
        getDocs(incomingQ1),
        getDocs(incomingQ2)
      ]);
      const normalizeIncoming = (d: any) => {
        const data = d.data();
        const createdAt = (data.createdAt?.toDate?.() || data.createdAt || new Date()) as Date;
        const updatedAt = (data.updatedAt?.toDate?.() || data.updatedAt || createdAt) as Date;
        const fromUserId = data.fromUserId || data.senderId;
        const toUserId = data.toUserId || data.receiverId;
        return {
          id: d.id,
          ...data,
          fromUserId,
          toUserId,
          fromUserName: data.fromUserName || data.senderName || 'Onbekend',
          toUserName: data.toUserName || data.receiverName || 'Onbekend',
          createdAt,
          updatedAt
        } as ConnectionRequest as any;
      };
      const incomingCombined = [...incomingS1.docs, ...incomingS2.docs].map(normalizeIncoming);
      // Dedupe by pair (A|B) keeping latest
      const incomingMap = new Map<string, any>();
      incomingCombined.forEach((r: any) => {
        const a = String(r.fromUserId);
        const b = String(r.toUserId);
        const key = a < b ? `${a}|${b}` : `${b}|${a}`;
        const prev = incomingMap.get(key);
        if (!prev || (prev.createdAt < r.createdAt)) incomingMap.set(key, r);
      });
      setIncomingRequests(Array.from(incomingMap.values()));

      // Load sent requests (support both legacy from/to and sender/receiver fields)
      const sentQ1 = query(
        collection(db, 'connectionRequests'),
        where('fromUserId', '==', userProfile?.uid),
        where('status', '==', 'pending')
      );
      const sentQ2 = query(
        collection(db, 'connectionRequests'),
        where('senderId', '==', userProfile?.uid),
        where('status', '==', 'pending')
      );
      const [sentS1, sentS2] = await Promise.all([
        getDocs(sentQ1),
        getDocs(sentQ2)
      ]);
      const normalizeSent = (d: any) => {
        const data = d.data();
        const createdAt = (data.createdAt?.toDate?.() || data.createdAt || new Date()) as Date;
        const updatedAt = (data.updatedAt?.toDate?.() || data.updatedAt || createdAt) as Date;
        const fromUserId = data.fromUserId || data.senderId;
        const toUserId = data.toUserId || data.receiverId;
        return {
          id: d.id,
          ...data,
          fromUserId,
          toUserId,
          fromUserName: data.fromUserName || data.senderName || 'Onbekend',
          toUserName: data.toUserName || data.receiverName || 'Onbekend',
          createdAt,
          updatedAt
        } as ConnectionRequest as any;
      };
      const sentCombined = [...sentS1.docs, ...sentS2.docs].map(normalizeSent);
      const sentMap = new Map<string, any>();
      sentCombined.forEach((r: any) => {
        const a = String(r.fromUserId);
        const b = String(r.toUserId);
        const key = a < b ? `${a}|${b}` : `${b}|${a}`;
        const prev = sentMap.get(key);
        if (!prev || (prev.createdAt < r.createdAt)) sentMap.set(key, r);
      });
      setSentRequests(Array.from(sentMap.values()));

      // Platformbreed online-tal: alleen voor admins (anders verwarrend t.o.v. eigen connecties)
      try {
        if (canSeePlatformOnlineStats(userProfile?.email)) {
          const { query: q, where: w } = await import('firebase/firestore');
          const onlineSnap = await getDocs(q(collection(db, 'userProfiles'), w('isOnline', '==', true)));
          setOnlineUsers(onlineSnap.size || 0);
        } else {
          setOnlineUsers(0);
        }
      } catch {
        setOnlineUsers(0);
      }

      // Build community profiles list from connections
      const otherUserIds = new Set<string>();
      connections.forEach(c => {
        if (c.user1Id === (userProfile?.uid || '')) {
          otherUserIds.add(String(c.user2Id));
        } else if (c.user2Id === (userProfile?.uid || '')) {
          otherUserIds.add(String(c.user1Id));
        }
      });
      
      const profiles = allMembers.filter(m => otherUserIds.has(String(m.uid)));
      setCommunityProfiles(profiles);

      // Load current user's extended profile for signature defaults
      try {
        if (userProfile?.uid) {
          const pSnap = await getDoc(doc(db, 'userProfiles', userProfile.uid));
          if (pSnap.exists()) {
            const data: any = pSnap.data();
            const me: UserProfile = {
              uid: data.uid || userProfile.uid,
              displayName: data.displayName || (userProfile as any)?.displayName || 'Gebruiker',
              email: data.email || (userProfile as any)?.email || '',
              photoURL: data.photoURL || (userProfile as any)?.photoURL,
              bio: data.bio,
              company: data.company,
              role: data.role,
              location: data.location,
              interests: data.interests || [],
              joinDate: data.joinedAt?.toDate?.() || new Date(),
              lastSeen: data.lastActive?.toDate?.() || new Date(),
              socialSharingEnabled: data.socialSharingEnabled || false,
              sharingFrequency: data.sharingFrequency || 3,
              totalShares: data.totalShares || 0,
              connectionStatus: data.connectionStatus || 'none',
              points: data.points || 0,
              isOnboarded: data.isOnboarded || false
            } as UserProfile;
            setSelfProfileDoc(me);
          }
        }
      } catch {}

      // Load recent posts (7d) grouped by userId
      try {
        const since = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        const postsSnap = await getDocs(query(collection(db, 'communityPosts'), where('timestamp', '>=', since)) as any);
        const map: Record<string, number> = {};
        postsSnap.docs.forEach(d => {
          const u = String((d.data() as any)?.userId || '');
          if (!u) return; map[u] = (map[u] || 0) + 1;
        });
        setPosts7dByUser(map);
      } catch {}

      // Load chat rooms and count messages received (7d) per user
      try {
        const roomsSnap = await getDocs(query(collection(db, 'chatRooms'), where('participants', 'array-contains', userProfile?.uid || '')));
        const roomIdToOther: Record<string, string> = {};
        roomsSnap.docs.forEach(r => {
          const data = r.data() as any; const ps: string[] = data.participants || [];
          const other = ps.find((p: string) => p !== (userProfile?.uid || ''));
          if (other) roomIdToOther[r.id] = other;
        });
        const since = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        const msgs: Record<string, number> = {};
        // Query per room for messages sent by the other participant in last 7d
        for (const [roomId, otherId] of Object.entries(roomIdToOther)) {
          try {
            const q = query(
              collection(db, 'chatMessages'),
              where('chatRoomId', '==', roomId),
              where('senderId', '==', otherId),
              where('timestamp', '>=', since)
            );
            const snap = await getDocs(q);
            msgs[otherId] = (msgs[otherId] || 0) + snap.size;
          } catch (e) {}
        }
        setMsgs7dByUser(msgs);
      } catch {}

      // Load invite templates for current user
      try {
        const tQ = query(
          collection(db, 'inviteTemplates'),
          where('ownerId', '==', userProfile?.uid || ''),
          orderBy('createdAt', 'desc')
        );
        const tSnap = await getDocs(tQ);
        const tpls = tSnap.docs.map(d => ({
          id: d.id,
          name: (d.data() as any)?.name || 'Template',
          subject: (d.data() as any)?.subject || defaultInviteSubject,
          body: (d.data() as any)?.body || buildDefaultInviteBody()
        }));
        if (tpls.length === 0) {
          const def = { id: 'default', name: 'Standaard', subject: defaultInviteSubject, body: buildDefaultInviteBody() };
          setInviteTemplates([def]);
          setSelectedTemplateId('default');
          setTemplateName('Standaard');
          setTemplateSubject(defaultInviteSubject);
          setTemplateBody(buildDefaultInviteBody());
        } else {
          setInviteTemplates(tpls);
          const first = tpls[0];
          setSelectedTemplateId(first.id);
          setTemplateName(first.name);
          setTemplateSubject(first.subject);
          setTemplateBody(first.body);
        }
      } catch {}

    } catch (error) {
      console.error('Error loading additional data:', error);
    }
  };

  const [sendingRequest, setSendingRequest] = useState(false);

  const sendConnectionRequest = async (toUserId: string) => {
    console.log('🔵 sendConnectionRequest called with:', toUserId);
    console.log('🔵 userProfile:', userProfile?.uid);
    console.log('🔵 selectedMember:', selectedMember);
    console.log('🔵 requestMessage:', requestMessage);
    console.log('🔵 isKnownContact:', isKnownContact);
    
    if (!userProfile) {
      console.error('❌ No userProfile!');
      alert('Je bent niet ingelogd. Probeer opnieuw.');
      return;
    }
    if (sendingRequest) {
      console.log('⏭️ Already sending, skipping...');
      return;
    }
    setSendingRequest(true);

    try {
      // ✅ FIX: Use selectedMember if available (from OpenForConnectionsList), otherwise search in allMembers
      const toUser = selectedMember?.uid === toUserId 
        ? selectedMember 
        : allMembers.find(member => member.uid === toUserId);
      
      console.log('🔵 toUser found:', toUser);
      
      if (!toUser) {
        console.error('❌ Could not find user with id:', toUserId);
        alert('Kon de gebruiker niet vinden. Probeer opnieuw.');
        setSendingRequest(false);
        return;
      }

      // Prevent duplicate pending requests between the same two users (both schema variants, both directions)
      console.log('🔵 Checking for existing requests...');
      const pendingChecks = await Promise.all([
        getDocs(query(collection(db, 'connectionRequests'), where('fromUserId', '==', userProfile.uid), where('toUserId', '==', toUserId), where('status', '==', 'pending'))),
        getDocs(query(collection(db, 'connectionRequests'), where('senderId', '==', userProfile.uid), where('receiverId', '==', toUserId), where('status', '==', 'pending'))),
        getDocs(query(collection(db, 'connectionRequests'), where('fromUserId', '==', toUserId), where('toUserId', '==', userProfile.uid), where('status', '==', 'pending'))),
        getDocs(query(collection(db, 'connectionRequests'), where('senderId', '==', toUserId), where('receiverId', '==', userProfile.uid), where('status', '==', 'pending')))
      ]);
      const hasPending = pendingChecks.some(s => s.size > 0);
      console.log('🔵 Has pending:', hasPending);
      
      if (hasPending) {
        alert('Er bestaat al een open connectieverzoek tussen jullie.');
        setSendingRequest(false);
        return;
      }

      const requestData: any = {
        // legacy fields
        fromUserId: userProfile.uid,
        toUserId: toUserId,
        fromUserName: userProfile.displayName || 'Onbekend',
        toUserName: toUser.displayName,
        fromUserPhoto: userProfile.photoURL,
        toUserPhoto: toUser.photoURL || '',
        // new aligned fields for other views
        senderId: userProfile.uid,
        receiverId: toUserId,
        senderName: userProfile.displayName || 'Onbekend',
        receiverName: toUser.displayName,
        senderPhoto: userProfile.photoURL,
        receiverPhoto: toUser.photoURL || '',
        // message/status/dates
        message: requestMessage || '',
        status: 'pending',
        createdAt: new Date(),
        updatedAt: new Date()
      };

      // Add knownContact if checkbox is checked
      if (isKnownContact) {
        requestData.knownContact = {
          markedBy: userProfile.uid,
          markedAt: new Date(),
          status: 'pending'
        };
        console.log('🔵 Added knownContact data');
      }

      console.log('🔵 Sending request with data:', requestData);
      const docRef = await addDoc(collection(db, 'connectionRequests'), requestData);
      console.log('✅ Request sent successfully! Doc ID:', docRef.id);

      setRequestMessage('');
      setIsKnownContact(false);
      setShowRequestModal(false);
      setSelectedMember(null);
      loadEssentialData();
      
      alert('✅ Connectie verzoek verzonden!');
    } catch (error) {
      console.error('❌ Error sending connection request:', error);
      alert('❌ Er ging iets mis bij het verzenden van het verzoek: ' + (error as Error).message);
    } finally {
      setSendingRequest(false);
    }
  };

  const handleConnectionRequest = async (requestId: string, action: 'accept' | 'decline') => {
    try {
      await updateDoc(doc(db, 'connectionRequests', requestId), {
        status: action === 'accept' ? 'accepted' : 'declined',
        updatedAt: new Date()
      });

      if (action === 'accept') {
        const request = incomingRequests.find(r => r.id === requestId);
        if (request) {
          // Check if connection already exists (e.g. from known contact direct connect)
          const { query, where, getDocs } = await import('firebase/firestore');
          const existingConnections1 = await getDocs(query(
            collection(db, 'connections'),
            where('user1Id', '==', request.fromUserId),
            where('user2Id', '==', request.toUserId)
          ));
          const existingConnections2 = await getDocs(query(
            collection(db, 'connections'),
            where('user1Id', '==', request.toUserId),
            where('user2Id', '==', request.fromUserId)
          ));
          
          if (existingConnections1.empty && existingConnections2.empty) {
            // Create connection only if it doesn't exist
            await addDoc(collection(db, 'connections'), {
              user1Id: request.fromUserId,
              user2Id: request.toUserId,
              user1Name: request.fromUserName,
              user2Name: request.toUserName,
              user1Photo: request.fromUserPhoto,
              user2Photo: userProfile?.photoURL,
              createdAt: new Date(),
              chatCount: 0
            });
          } else {
            console.log('✅ Connection already exists, skipping creation');
          }
        }
      }

      loadEssentialData();
    } catch (error) {
      console.error('Error handling connection request:', error);
    }
  };

  const openChatWithConnection = async (connection: Connection) => {
    // Prevent double clicks
    if (connection.user1Id === userProfile?.uid && connection.user2Id) {
      const connectionKey = `chat_${connection.user1Id}_${connection.user2Id}`;
      if (localStorage.getItem(connectionKey)) {
        console.log('Chat navigation already in progress');
        return;
      }
      localStorage.setItem(connectionKey, 'true');
      setTimeout(() => localStorage.removeItem(connectionKey), 2000);
    }
    
    try {
      const otherUserId = connection.user1Id === userProfile?.uid ? connection.user2Id : connection.user1Id;
      const otherUserName = connection.user1Id === userProfile?.uid ? connection.user2Name : connection.user1Name;
      const otherUserPhoto = connection.user1Id === userProfile?.uid ? connection.user2Photo : connection.user1Photo;

      // Check if chat room already exists
      const existingRoomQuery = query(
        collection(db, 'chatRooms'),
        where('participants', 'array-contains', userProfile?.uid)
      );
      
      const existingRoomsSnapshot = await getDocs(existingRoomQuery);
      const existingRoom = existingRoomsSnapshot.docs.find(doc => {
        const data = doc.data();
        return data.participants.includes(otherUserId);
      });

      if (!existingRoom) {
        // Create new chat room
        const newRoomData = {
          participants: [userProfile?.uid, otherUserId],
          participantNames: [userProfile?.displayName || 'Onbekend', otherUserName || 'Onbekend'],
          participantPhotos: [userProfile?.photoURL || '', otherUserPhoto || ''],
          messageCount: 0,
          unreadCount: { [userProfile?.uid || '']: 0, [otherUserId]: 0 },
          createdAt: new Date(),
          callTriggerData: {
            messagesSinceLastTrigger: 0,
            triggerShown: false
          }
        };

        await addDoc(collection(db, 'chatRooms'), newRoomData);
        console.log('Chat room created for connection:', connection);
      }

      // Navigate to chat with this specific user
      // Use navigation helper - integrates with AI Assistant
      localStorage.setItem('selectedChatUser', JSON.stringify({
        userId: otherUserId,
        userName: otherUserName,
        userPhoto: otherUserPhoto
      }));
      
      setTimeout(() => {
        openChat();
      }, 100);
    } catch (error) {
      console.error('Error opening chat with connection:', error);
    }
  };

  const filteredMembers = allMembers.filter(member =>
    member.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    member.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    member.company?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Navigation helpers for cross-section cards
  // removed unused openMovement function

  if (loading) {
    return (
      <>
        <div className="hidden md:block max-w-6xl mx-auto p-6">
          <PageHeader 
            title="Netwerk"
            subtitle="Beheer je connecties en bouw relaties op"
          />

          <div className="grid grid-cols-2 lg:grid-cols-6 gap-1 mb-6 bg-gray-100 rounded-lg p-1">
            <div className="h-8 bg-blue-100 border border-blue-300 rounded-md flex items-center justify-center">
              <span className="text-blue-700 text-xs font-medium">ConnectFlow</span>
            </div>
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-8 bg-gray-200 rounded-md animate-pulse" />
            ))}
          </div>

          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="flex items-center space-x-4 mb-2">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" />
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
                  <div className="h-3 bg-gray-100 rounded w-48" />
                </div>
              </div>
            </div>
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="bg-white rounded-lg shadow-sm p-4 h-24">
                <div className="flex items-center space-x-4 mb-2">
                  <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse flex-shrink-0" />
                  <div className="flex-1">
                    <div className="h-4 bg-gray-200 rounded w-32 mb-1 animate-pulse" />
                    <div className="h-3 bg-gray-200 rounded w-40 animate-pulse" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="block md:hidden h-full min-h-0 overflow-hidden bg-[#F4F1EA] px-4 pt-4">
          <div className="space-y-3">
            <div className="rounded-2xl border border-[#E8E4DC] bg-white/85 p-4 shadow-sm">
              <div className="h-4 w-32 animate-pulse rounded-full bg-[#E8E4DC]" />
              <div className="mt-2 h-3 w-52 animate-pulse rounded-full bg-[#EDE9E1]" />
            </div>
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="rounded-2xl border border-[#E8E4DC] bg-white/85 p-3 shadow-sm">
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 flex-shrink-0 animate-pulse rounded-full bg-[#E8E4DC]" />
                  <div className="min-w-0 flex-1">
                    <div className="h-3.5 w-28 animate-pulse rounded-full bg-[#E8E4DC]" />
                    <div className="mt-2 h-3 w-40 animate-pulse rounded-full bg-[#EDE9E1]" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }

  const showPlatformOnlineCount = canSeePlatformOnlineStats(userProfile?.email);

  return (
    <>
      {/* DESKTOP LAYOUT - Volledig gewrapped */}
      <div className="quiet-lounge hidden md:block min-h-screen p-4 md:p-6 overflow-x-hidden mobile-snap-container" style={{ backgroundColor: '#F4F4F1' }}>
      <div className="max-w-5xl mx-auto w-full overflow-x-hidden">
        {/* Header - Mobile optimized */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 md:mb-6 gap-3">
          {/* Professional LinkedIn-style header - geen grote emoji's */}
          <div className="mb-4">
            <h1 className="text-xl md:text-2xl font-semibold text-gray-900">Mijn netwerk</h1>
            <p className="text-sm text-gray-600 mt-1">
              {connections.length} connecties
              {showPlatformOnlineCount ? ` • ${onlineUsers} online` : ''}
            </p>
          </div>
          
          {/* Dev tools - compacter en minder prominent */}
          <div className="hidden md:flex items-center gap-2 mb-4">
            <button
              onClick={handleResetMyConnectionRequests}
              className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-xs font-medium"
              title="Reset mijn verzoeken"
            >
              Reset
            </button>
            <button
              onClick={() => setShowCleanConfirm(true)}
              className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-xs font-medium"
              title="Clean test accounts"
            >
              Clean
            </button>
          </div>
        </div>
        
        {/* LinkedIn-style layout: Single column on mobile, sidebar below content */}
        <div className="flex flex-col md:grid md:grid-cols-12 gap-4 md:gap-8 w-full overflow-x-hidden">

      {/* Sidebar - Clean dropdown menu op mobiel, sidebar op desktop */}
      <aside className="order-2 md:order-1 md:col-span-4 lg:col-span-3 w-full overflow-x-hidden">
        {/* Mobile: Clean dropdown menu bovenin */}
        <div className="md:hidden mb-4">
          <div className="bg-white border-b border-gray-200">
            {/* Profile - Compact */}
            <div className="px-3 py-2 flex items-center space-x-2 border-b border-gray-100">
              <img
                src={getValidProfilePhoto(userProfile || null, null)}
                alt="Profile"
                className="w-8 h-8 rounded-full object-cover"
                style={{
                  objectPosition: userProfile?.photoPosition 
                    ? `${userProfile.photoPosition.x}% ${userProfile.photoPosition.y}%` 
                    : 'center'
                }}
                onError={(e) => {
                  const t = e.currentTarget as HTMLImageElement;
                  t.src = 'https://ui-avatars.com/api/?name=U&background=cccccc&color=fff&size=128';
                }}
              />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-gray-900 truncate">{userProfile?.displayName || 'Gebruiker'}</div>
                <div className="text-xs text-gray-500">
                  {showPlatformOnlineCount ? `${onlineUsers} online • ` : ''}
                  {connections.length} connecties
                </div>
              </div>
            </div>

            {/* Dropdown Menu - Apple style, thumb-friendly */}
            <div className="px-2 py-1">
              <button
                onClick={() => { setActiveTab('chatflow'); }}
                className={`w-full text-left px-3 py-3 rounded-lg text-sm transition-colors min-h-[44px] flex items-center ${
                  activeTab === 'chatflow' 
                    ? 'bg-stone-50 text-[#4F6660] font-medium' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span>Chat</span>
              </button>
              <button
                onClick={() => { toggleCard('connections'); setActiveTab('chat-interface'); }}
                className={`w-full text-left px-3 py-3 rounded-lg text-sm transition-colors min-h-[44px] flex items-center ${
                  activeTab === 'chat-interface' || activeTab === 'requests' || activeTab === 'sent' || activeTab === 'connections'
                    ? 'bg-stone-50 text-[#4F6660] font-medium' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span>Connecties</span>
              </button>
              {/* Hidden - AI Matchmaker module
              <button
                onClick={() => { toggleCard('discover'); setActiveTab('ai-matching'); }}
                className={`w-full text-left px-3 py-3 rounded-lg text-sm transition-colors min-h-[44px] flex items-center ${
                  activeTab === 'ai-matching' || activeTab === 'partner-connect' || activeTab === 'verbinden-met' || activeTab === 'open-for-connections'
                    ? 'bg-stone-50 text-[#4F6660] font-medium' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span>Ontdek</span>
              </button>
              */}
              <button
                onClick={() => toggleCard('community')}
                className={`w-full text-left px-3 py-3 rounded-lg text-sm transition-colors min-h-[44px] flex items-center ${
                  openCard === 'community'
                    ? 'bg-stone-50 text-[#4F6660] font-medium' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span>Community</span>
              </button>
            </div>
          </div>

          {/* Submenu items - Thumb-friendly, alleen tonen wanneer actief */}
          {openCard === 'connections' && (
            <div className="bg-gray-50 border-b border-gray-200 px-2 py-1">
              <button onClick={() => setActiveTab('requests')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'requests' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                Ontvangen {incomingRequests.length > 0 && <span className="ml-1 text-xs">({incomingRequests.length})</span>}
              </button>
              <button onClick={() => setActiveTab('sent')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'sent' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                Verzonden {sentRequests.length > 0 && <span className="ml-1 text-xs">({sentRequests.length})</span>}
              </button>
              <button onClick={() => setActiveTab('connections')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'connections' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                Alle connecties <span className="ml-1 text-xs">({connections.length})</span>
              </button>
            </div>
          )}

          {/* Hidden - AI Matchmaker submenu
          {openCard === 'discover' && (
            <div className="bg-gray-50 border-b border-gray-200 px-2 py-1">
              <button onClick={() => setActiveTab('ai-matching')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'ai-matching' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                AI Matchmaker
              </button>
              <button onClick={() => setActiveTab('partner-connect')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'partner-connect' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                Partner match
              </button>
              <button onClick={() => setActiveTab('verbinden-met')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'verbinden-met' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                Verbinden met <span className="ml-1 text-xs">({regionalUsers.length})</span>
              </button>
              <button onClick={() => setActiveTab('open-for-connections')} className={`w-full text-left px-3 py-3 rounded-lg text-sm min-h-[44px] flex items-center ${activeTab === 'open-for-connections' ? 'text-[#4F6660] font-medium bg-stone-50' : 'text-gray-700'}`}>
                <span>Open voor connecties</span>
              </button>
            </div>
          )}
          */}

          {openCard === 'community' && (
            <div className="bg-gray-50 border-b border-gray-200 px-3 py-2">
              <input
                type="text"
                placeholder="Zoek community lid..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-3 py-3 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-[#7A9488] focus:border-[#7A9488] min-h-[44px]"
              />
              <button onClick={() => setInviteOpen(true)} className="mt-2 w-full text-left px-3 py-3 text-sm text-[#4F6660] hover:bg-stone-50 rounded-lg min-h-[44px] flex items-center">
                Nodig iemand uit via e-mail
              </button>
            </div>
          )}
        </div>

        {/* Desktop: Originele sidebar */}
        <div className="hidden md:block space-y-4">
          <AdminMutePanel page="network" />
          
          {/* Profile Card */}
          <div className="bg-white rounded-lg shadow-sm border p-4">
            <div className="flex items-center space-x-3 mb-2">
              <img
                src={getValidProfilePhoto(userProfile || null, null)}
                alt="Profile"
                className="w-12 h-12 rounded-full object-cover"
                style={{
                  objectPosition: userProfile?.photoPosition 
                    ? `${userProfile.photoPosition.x}% ${userProfile.photoPosition.y}%` 
                    : 'center'
                }}
                onError={(e) => {
                  const t = e.currentTarget as HTMLImageElement;
                  t.src = 'https://ui-avatars.com/api/?name=U&background=cccccc&color=fff&size=128';
                }}
              />
              <div>
                <h3 className="font-semibold">{userProfile?.displayName || 'Gebruiker'}</h3>
                <p className="text-sm text-gray-500">Ondernemer</p>
              </div>
            </div>
            <div className="text-sm text-gray-600">
              {(userProfile as any)?.posts || 0} posts
              {showPlatformOnlineCount ? ` • ${onlineUsers} online` : ''} • {connections.length} connecties
            </div>
          </div>

          {/* Desktop cards - Origineel design */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 flex items-center justify-between cursor-pointer" onClick={() => { toggleCard('chatflow'); setActiveTab('chatflow'); }}>
              <div className="flex items-center space-x-2">
                <RefreshCw size={18} className="text-gray-500" />
                <div>
                  <h3 className="font-medium text-gray-900 text-sm">ConnectFlow</h3>
                  <p className="text-sm text-gray-500">Berichten en flow</p>
                </div>
              </div>
              <span className="text-gray-500">{openCard === 'chatflow' ? '▾' : '▸'}</span>
            </div>
          </div>

          {/* Open voor connecties kaart */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 flex items-center justify-between cursor-pointer" onClick={() => setActiveTab('open-for-connections')}>
              <div className="flex items-center space-x-2">
                <Star size={18} className="text-gray-500" />
                <div>
                  <h3 className="font-medium text-gray-900 text-sm">Open voor connecties</h3>
                  <p className="text-sm text-gray-500">Beschikbaar om te verbinden</p>
                </div>
              </div>
            </div>
          </div>


          {/* Ontdek, Connecties, etc. - Desktop versie */}
          {/* Hidden incomplete module - AI Matchmaker en Partners
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 flex items-center justify-between cursor-pointer" onClick={() => { toggleCard('discover'); setActiveTab('ai-matching'); }}>
              <div className="flex items-center space-x-2">
                <Search size={18} className="text-gray-500" />
                <div>
                  <h3 className="font-medium text-gray-900 text-sm">Ontdek</h3>
                  <p className="text-sm text-gray-500">AI Matchmaker en Partners</p>
                </div>
              </div>
              <span className="text-gray-500">{openCard === 'discover' ? '▾' : '▸'}</span>
            </div>
            {openCard === 'discover' && (
              <div className="px-4 pb-4 space-y-1">
                <button onClick={() => setActiveTab('ai-matching')} className="text-sm text-gray-700 hover:underline text-left">AI Matchmaker</button>
                <button onClick={() => setActiveTab('partner-connect')} className="text-sm text-gray-700 hover:underline text-left">Partner match</button>
                <button onClick={() => setActiveTab('verbinden-met')} className="text-sm text-gray-700 hover:underline text-left">Verbinden met ({regionalUsers.length})</button>
                <button onClick={() => setActiveTab('open-for-connections')} className="text-sm text-gray-700 hover:underline text-left">Open voor connecties</button>
                <button onClick={() => setActiveTab('matchmaking')} className="text-sm text-gray-700 hover:underline text-left">Matchmaking</button>
              </div>
            )}
          </div>
          */}

          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 flex items-center justify-between cursor-pointer" onClick={() => { setActiveTab('chat-interface'); }}>
              <div className="flex items-center space-x-2">
                <ChatIcon size={18} weight="regular" className="text-gray-500" />
                <div>
                  <h3 className="font-medium text-gray-900 text-sm">Chats</h3>
                  <p className="text-sm text-gray-500">Verzonden en Ontvangen</p>
                </div>
              </div>
              <span className="text-gray-500">{openCard === 'connections' ? '▾' : '▸'}</span>
            </div>
            {openCard === 'connections' && (
              <div className="px-4 pb-4 space-y-1">
                <button onClick={() => setActiveTab('requests')} className="text-sm text-gray-700 hover:underline text-left">Ontvangen {incomingRequests.length > 0 ? `(${incomingRequests.length})` : ''}</button>
                <button onClick={() => setActiveTab('sent')} className="text-sm text-gray-700 hover:underline text-left">Verzonden {sentRequests.length > 0 ? `(${sentRequests.length})` : ''}</button>
                <button onClick={() => setActiveTab('connections')} className="text-sm text-gray-700 hover:underline text-left">Connecties ({connections.length})</button>
                <button onClick={() => setActiveTab('all')} className="text-sm text-gray-700 hover:underline text-left">Alle leden ({filteredMembers.length})</button>
              </div>
            )}
          </div>
        </div>
      </aside>

      {/* Main - Full width on mobile, sidebar layout on desktop */}
      <main className="order-1 md:order-2 md:col-span-8 lg:col-span-9 space-y-4 md:space-y-6 w-full overflow-x-hidden mobile-snap-section">
        {activeTab === 'chatflow' && (
          <div className="bg-white rounded-lg border border-gray-200 p-0 shadow-sm overflow-hidden">
            <ConnectieFlow />
          </div>
        )}

        {activeTab === 'chat-interface' && (
          <div className="bg-white rounded-lg border border-gray-200 p-0 shadow-sm overflow-hidden">
            <ChatInterface />
          </div>
        )}

        {activeTab === 'ai-matching' && (
          <AIMatchmaking userProfile={userProfile} />
        )}

        {activeTab === 'partner-connect' && (
          <PartnerConnect userProfile={userProfile} />
        )}

        {activeTab === 'all' && (
          <div>
            {filteredMembers.length === 0 ? (
              <div className="text-center py-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">Nog geen connecties gemaakt</h3>
                <p className="text-gray-600 mb-3 text-sm">
                  Begin met het maken van connecties door op "Verbinden met" te klikken.
                </p>
                <button
                  onClick={() => setActiveTab('verbinden-met')}
                  className="bg-[#2E5F56] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#265049] transition-colors text-sm"
                >
                  Ontdek mensen in jouw regio
                </button>
                
            {/* Region Options - Collapsible */}
            <div className="mt-4 bg-gray-50 rounded-lg p-3">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium text-gray-700">Beschikbare regio's:</h4>
                <button
                  onClick={() => setShowRegionOptions(!showRegionOptions)}
                  className="text-xs text-blue-600 hover:text-blue-800 underline"
                >
                  {showRegionOptions ? '🔼 Verberg' : '🔽 Toon regio\'s'}
                </button>
              </div>
              
              {showRegionOptions && (
                <>
                  {/* Nederland Provincies */}
                  <div className="mb-3">
                    <h5 className="text-xs font-semibold text-gray-600 mb-2">
                      Nederland (lokaal)
                    </h5>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-1 text-xs">
                      {[
                        'Noord-Holland',
                        'Zuid-Holland', 
                        'Utrecht',
                        'Flevoland',
                        'Gelderland',
                        'Overijssel',
                        'Drenthe',
                        'Friesland',
                        'Groningen',
                        'Noord-Brabant',
                        'Limburg',
                        'Zeeland'
                      ].map((provincie) => (
                        <label key={provincie} className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-1 rounded">
                          <input
                            type="checkbox"
                            checked={selectedRegions.includes(provincie)}
                            onChange={() => handleRegionToggle(provincie)}
                            className="form-checkbox h-3 w-3 text-blue-600"
                          />
                          <span className="text-gray-700">{provincie}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Andere Regio's */}
                  <div className="mb-3">
                    <h5 className="text-xs font-semibold text-gray-600 mb-2">
                      Andere regio's
                    </h5>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-1 text-xs">
                      {[
                        'België - Vlaanderen',
                        'België - Wallonië',
                        'Duitsland',
                        'Frankrijk',
                        'Verenigd Koninkrijk',
                        'Internationaal'
                      ].map((region) => (
                        <label key={region} className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-1 rounded">
                          <input
                            type="checkbox"
                            checked={selectedRegions.includes(region)}
                            onChange={() => handleRegionToggle(region)}
                            className="form-checkbox h-3 w-3 text-blue-600"
                          />
                          <span className="text-gray-700">{region}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-200">
                    <p className="text-xs text-gray-500">
                      {selectedRegions.length > 0 
                        ? `${selectedRegions.length} regio(s) geselecteerd` 
                        : 'Selecteer je gewenste regio\'s voor netwerken.'
                      }
                    </p>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => setShowWorkScopeSettings(true)}
                        className="text-xs text-blue-600 hover:text-blue-800 underline"
                      >
                        Instellingen
                      </button>
                      {selectedRegions.length > 0 && (
                        <span className="text-xs text-green-600">✅ Opgeslagen</span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredMembers.map(member => (
              <div key={member.uid} className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm  transition-shadow">
                <div className="flex items-center space-x-4 mb-4">
                  {member.photoURL ? (
                    <img src={member.photoURL} alt={member.displayName} className="w-12 h-12 rounded-full"
                      onError={(e) => {
                        const initials = (member.displayName || 'U').split(' ').map((n: string) => n[0]).join('').toUpperCase().slice(0, 2);
                        (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=4F6660&color=fff&size=96`;
                      }}
                    />
                  ) : (
                    <div className="w-12 h-12 bg-[#2E5F56] rounded-full flex items-center justify-center">
                      <span className="text-white font-semibold text-lg">
                        {member.displayName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <div>
                    <h3 className="font-semibold text-gray-900">{member.displayName}</h3>
                    <p className="text-sm text-gray-600">{member.company || 'Geen bedrijf'}</p>
                  </div>
                </div>
                
                {member.bio && (
                  <p className="text-gray-700 text-sm mb-4 line-clamp-2">{member.bio}</p>
                )}
                
                <div className="flex justify-between items-center">
                  <button
                    onClick={() => {
                      setSelectedMember(member);
                      setShowRequestModal(true);
                    }}
                    className="bg-[#2E5F56] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#265049] "
                  >
                    Verzoek Versturen
                  </button>
                  <span className="text-xs text-gray-500">
                    {member.lastActive.toLocaleDateString('nl-NL')}
                  </span>
                </div>
              </div>
            ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'verbinden-met' && (
          <div>
            <div className="mb-4">
              <h2 className="text-base font-semibold text-gray-900 mb-1">
                Verbinden met mensen in jouw werkgebied
              </h2>
              <p className="text-sm text-gray-600 mb-3">
                Ontdek andere ondernemers die compatibel zijn met jouw werkgebied.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-800">
                  <strong>Jouw werkgebied:</strong> {
                    (userProfile as any)?.workScope === 'internationaal' ? 'Internationaal' :
                    (userProfile as any)?.workScope === 'nationaal' ? `Nationaal (${(userProfile as any)?.workScopeCountry || (userProfile as any)?.country || 'Nederland'})` :
                    `Lokaal (${(userProfile as any)?.region || 'jouw regio'})`
                  }
                </p>
                <button
                  onClick={() => setShowWorkScopeSettings(true)}
                  className="mt-2 text-xs text-blue-600 hover:text-blue-800 font-medium"
                >
                  Werkgebied aanpassen →
                </button>
              </div>
            </div>

            {loadingRegionalUsers ? (
              <div className="flex items-center justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-sm text-gray-600">Laden...</span>
              </div>
            ) : regionalUsers.length === 0 ? (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <h3 className="text-base font-medium text-gray-900 mb-1">Geen nieuwe connecties beschikbaar</h3>
                <p className="text-sm text-gray-600">
                  Er zijn momenteel geen andere ondernemers in {(userProfile as any)?.region || 'jouw regio'} beschikbaar om mee te verbinden.
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {regionalUsers.map(user => (
                  <div key={user.uid} className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-center space-x-3 mb-3">
                      {user.photoURL ? (
                        <img src={user.photoURL} alt={user.displayName} className="w-12 h-12 rounded-full"
                          onError={(e) => {
                            const initials = (user.displayName || 'U').split(' ').map((n: string) => n[0]).join('').toUpperCase().slice(0, 2);
                            (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=4F6660&color=fff&size=96`;
                          }}
                        />
                      ) : (
                        <div className="w-12 h-12 bg-[#2E5F56] rounded-full flex items-center justify-center">
                          <span className="text-white font-semibold text-base">
                            {user.displayName.charAt(0).toUpperCase()}
                          </span>
                        </div>
                      )}
                  <div>
                    <h3 className="font-medium text-gray-900 text-sm">{user.displayName}</h3>
                    <p className="text-xs text-gray-600">{user.company || 'Geen bedrijf'}</p>
                    <div className="flex items-center space-x-2 mt-1">
                      <p className="text-xs text-blue-600">{user.region}</p>
                      {user.workScope && (
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          user.workScope === 'internationaal' ? 'bg-[rgba(46,95,86,0.1)] text-[#2E5F56]' :
                          user.workScope === 'nationaal' ? 'bg-green-100 text-green-700' :
                          'bg-stone-100 text-[#4F6660]'
                        }`}>
                          {user.workScope === 'internationaal' ? 'Internationaal' :
                           user.workScope === 'nationaal' ? 'Nationaal' : 'Lokaal'}
                        </span>
                      )}
                    </div>
                  </div>
                    </div>
                    
                    {user.bio && (
                      <p className="text-gray-700 text-xs mb-3 line-clamp-2">{user.bio}</p>
                    )}
                    
                    <div className="flex justify-between items-center">
                      <button
                        onClick={() => {
                          setSelectedMember(user);
                          setShowRequestModal(true);
                        }}
                        className="bg-[#2E5F56] text-white px-3 py-2 rounded-lg text-xs font-medium hover:bg-[#265049] transition-colors min-h-[44px]"
                      >
                        Verbinden
                      </button>
                      <span className="text-xs text-gray-500">
                        {user.lastActive ? user.lastActive.toLocaleDateString('nl-NL') : 'Onbekend'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'matchmaking' && (
          <div>
            <div className="mb-4">
              <h2 className="text-base font-semibold text-gray-900 mb-1">
                Matchmaking - Stel mensen voor
              </h2>
              <p className="text-sm text-gray-600 mb-4">
                Stel mensen aan elkaar voor op basis van gedeelde interesses, connecties of doelen.
              </p>
            </div>
            <div className="bg-[#F7F5F0] border border-[#E0DDD8] rounded-lg p-4 mb-4">
              <p className="text-sm text-yellow-800">
                <strong>Tip:</strong> Gebruik de "Stel voor" knop bij mensen in de "Open voor netwerk" lijst of bij posts met gedeelde connecties.
              </p>
            </div>
            <div className="text-center py-8 text-gray-500">
              <p className="mb-2">Matchmaking functionaliteit is beschikbaar via:</p>
              <ul className="text-sm space-y-1 text-left max-w-md mx-auto">
                <li>• "Stel voor" knop bij posts met gedeelde connecties</li>
                <li>• "Stel voor" knop in de "Open voor netwerk" lijst</li>
                <li>• Via de uitgeklapte newsfeed</li>
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'open-for-connections' && (
          <div>
            <div className="mb-4">
              <h2 className="text-base font-semibold text-gray-900 mb-1">
                Open voor connecties
              </h2>
              <p className="text-sm text-gray-600">
                Deze gebruikers zijn beschikbaar om mee te verbinden.
              </p>
            </div>
            
            <OpenForConnectionsList 
              onConnect={(userId, userName, userPhoto) => {
                console.log('🟢 onConnect called from OpenForConnectionsList:', { userId, userName, userPhoto });
                // ✅ FIX: Open the modal instead of direct connect
                // Create a minimal UserProfile to open the modal
                const memberForModal = {
                  uid: userId,
                  displayName: userName,
                  photoURL: userPhoto || '',
                  email: '',
                  joinDate: new Date(),
                  socialSharingEnabled: false,
                  sharingFrequency: 7 as const,
                  totalShares: 0,
                  connectionStatus: 'none'
                } as UserProfile;
                
                console.log('🟢 Setting selectedMember:', memberForModal);
                setSelectedMember(memberForModal);
                setRequestMessage('');
                setIsKnownContact(false);
                setShowRequestModal(true);
                console.log('🟢 Modal should now be open');
              }}
            />
          </div>
        )}

        {activeTab === 'connections' && (
          <div>
            {/* Debug section - verborgen in productie */}
            {process.env.NODE_ENV === 'development' && (
            <div className="mb-4 p-4 bg-[#F7F5F0] border border-[#E0DDD8] rounded-lg">
              <h3 className="font-medium text-yellow-800 mb-2">Debug: Connection Issues</h3>
              <p className="text-sm text-yellow-700 mb-3">
                If your connection with Studio Antonio is not showing, click the button below to create it manually.
              </p>
              <button
                onClick={createTestConnection}
                className="px-4 py-2 bg-[#2E5F56] text-white hover:bg-[#265049] text-sm"
              >
                Create Test Connection with Studio Antonio
              </button>
            </div>
            )}
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {connections.map(connection => {
                const isUser1 = connection.user1Id === userProfile?.uid
                const otherName = isUser1 ? connection.user2Name : connection.user1Name
                const otherPhoto = isUser1 ? connection.user2Photo : connection.user1Photo
                const since = connection.createdAt?.toLocaleDateString?.('nl-NL') || ''
                const chats = Number(connection.chatCount || 0)
                return (
                  <div key={connection.id} className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm  transition-shadow">
                    <div className="flex items-start gap-4">
                      {otherPhoto ? (
                        <img src={otherPhoto} alt={otherName} className="w-12 h-12 rounded-full object-cover"
                          onError={(e) => {
                            const initials = (otherName || 'U').split(' ').map((n: string) => n[0]).join('').toUpperCase().slice(0, 2);
                            (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=4F6660&color=fff&size=96`;
                          }}
                        />
                      ) : (
                        <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 text-lg font-semibold">
                          {otherName?.charAt(0)?.toUpperCase?.() || 'U'}
                        </div>
                      )}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between gap-2">
                          <h3 className="font-semibold text-gray-900 truncate">{otherName || 'Connectie'}</h3>
                          {chats > 0 && (
                            <span className="shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-blue-50 text-blue-700 border border-blue-200" title="Aantal chats">
                              {chats} chats
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-gray-600 mt-0.5">Verbonden sinds {since}</p>
                        <div className="mt-3 flex items-center justify-end gap-2">
                          <button
                            onClick={() => openChatWithConnection(connection)}
                            className="px-3 py-1.5 rounded-lg bg-green-600 text-white text-sm font-medium hover:bg-green-700 "
                            aria-label={`Chat starten met ${otherName}`}
                          >
                            Chat
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            {connections.length === 0 && (
              <div className="text-center py-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Nog geen connecties</h3>
                <p className="text-gray-600">Start met het versturen van connectie verzoeken!</p>
              </div>
            )}
          </div>
        )}

        {activeTab === 'requests' && (
          <div className="space-y-4">
            {incomingRequests.map(request => (
              <div key={request.id} className={`bg-white rounded-lg border p-6 shadow-sm transition-shadow ${request.knownContact ? 'border-stone-300 bg-stone-50/30' : 'border-gray-200'}`}>
                {/* ✅ FIX: Always show known contact badge if they indicated they know you */}
                {request.knownContact && (
                  <div className="mb-3 flex items-center gap-2 px-3 py-2 bg-stone-100 border border-stone-200 rounded-lg">
                    <span className="text-lg">👋</span>
                    <span className="text-sm font-medium text-[#4A5A3D]">
                      Deze persoon geeft aan dat jullie elkaar al kennen
                    </span>
                  </div>
                )}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center ${request.knownContact ? 'bg-gradient-to-r from-[#7A9488] to-[#4F6660]' : 'bg-gradient-to-r from-[#7A9488] to-red-500'}`}>
                      <span className="text-white font-semibold text-lg">{request.knownContact ? '👋' : '📩'}</span>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="font-semibold text-gray-900">{request.fromUserName}</h3>
                        {request.knownContact && (
                          <span className="px-2 py-0.5 text-xs font-medium bg-stone-200 text-[#4A5A3D] rounded-full">
                            Bekende
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600">
                        {request.message || 'Wil graag met je verbinden'}
                      </p>
                      <p className="text-xs text-gray-500">
                        {request.createdAt.toLocaleDateString('nl-NL')}
                      </p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    {request.status === 'pending' && 
                     (!request.knownContact || request.knownContact.status !== 'pending') && (
                      <>
                        <button
                          onClick={() => handleConnectionRequest(request.id, 'accept')}
                          className="bg-green-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-green-700 "
                        >
                          Accepteren
                        </button>
                        <button
                          onClick={() => handleConnectionRequest(request.id, 'decline')}
                          className="bg-red-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-red-700 "
                        >
                          Weigeren
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* Known Contact Notification Card */}
                {request.status === 'pending' && 
                 request.knownContact && 
                 request.knownContact.status === 'pending' && (
                  <div className="mt-4 p-4 bg-gradient-to-r from-stone-50 to-stone-100 border-l-4 border-[#7A9488] rounded-lg">
                    <div className="flex items-start space-x-3">
                      <div className="flex-shrink-0">
                        <span className="text-2xl">👋</span>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-semibold text-[#4A5A3D] mb-2">
                          Bekend Contact
                        </h4>
                        <p className="text-sm text-[#4A5A3D] mb-3">
                          Deze persoon geeft aan dat jullie elkaar kennen. Wat wil je doen?
                        </p>
                        <div className="flex flex-col sm:flex-row gap-2">
                          <button
                            type="button"
                            onClick={async (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              
                              if (processingDirectConnect === request.id) {
                                console.log('⏭️ Already processing, skipping...');
                                return;
                              }
                              
                              setProcessingDirectConnect(request.id);
                              
                              try {
                                const { connectionRequestService } = await import('../services/connectionRequestService');
                                // Handle known contact response FIRST
                                await connectionRequestService.handleKnownContactResponse(request.id, 'direct_connect');
                                
                                // Create connection document (without newForUserIds to prevent popup)
                                const userIds = [userProfile?.uid, request.fromUserId].sort();
                                const connectionRef = await addDoc(collection(db, 'connections'), {
                                  user1Id: userIds[0],
                                  user2Id: userIds[1],
                                  status: 'accepted',
                                  createdAt: new Date(),
                                  acceptedAt: new Date(),
                                  knownContactDirectConnect: true // Flag to prevent popup
                                });
                                
                                console.log('✅ Connection created with knownContactDirectConnect flag:', connectionRef.id);
                                
                                // Accept the request directly (don't use handleConnectionRequest to avoid triggering normal flow)
                                await updateDoc(doc(db, 'connectionRequests', request.id), {
                                  status: 'accepted',
                                  updatedAt: new Date()
                                });
                                
                                await loadEssentialData();
                                alert('✅ Direct verbonden! Je kunt nu direct chatten.');
                              } catch (error) {
                                console.error('Error handling direct connect:', error);
                                alert('Er ging iets mis bij het direct connecten.');
                              } finally {
                                setProcessingDirectConnect(null);
                              }
                            }}
                            disabled={processingDirectConnect === request.id}
                            className={`flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm ${
                              processingDirectConnect === request.id ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                          >
                            {processingDirectConnect === request.id ? 'Bezig...' : '✓ Direct Connecten'}
                          </button>
                          <button
                            onClick={async () => {
                              try {
                                const { connectionRequestService } = await import('../services/connectionRequestService');
                                // Handle verify call response - accept but require verification call
                                await connectionRequestService.handleKnownContactResponse(request.id, 'verify_call');
                                
                                // Create connection document with verificationOnly flag
                                const userIds = [userProfile?.uid, request.fromUserId].sort();
                                const connectionRef = await addDoc(collection(db, 'connections'), {
                                  user1Id: userIds[0],
                                  user2Id: userIds[1],
                                  status: 'accepted',
                                  createdAt: new Date(),
                                  acceptedAt: new Date(),
                                  knownContact: request.knownContact,
                                  knownContactVerificationOnly: true // Skip chat, go directly to call
                                });
                                
                                console.log('✅ Connection created with verificationOnly flag:', connectionRef.id);
                                
                                // Accept the request
                                await updateDoc(doc(db, 'connectionRequests', request.id), {
                                  status: 'accepted',
                                  updatedAt: new Date()
                                });
                                
                                await loadEssentialData();
                                alert('✅ Connectie aangemaakt! Je kunt nu direct bellen om te verifiëren.');
                                
                                // Navigate to connecties to start call
                                window.location.hash = '#connecties';
                              } catch (error) {
                                console.error('Error handling verify call:', error);
                                alert('Er ging iets mis bij het aanmaken van de verificatie call.');
                              }
                            }}
                            className="flex-1 bg-[#2E5F56] hover:bg-[#265049] text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm"
                          >
                            📞 Verificatie bellen
                          </button>
                          <button
                            onClick={async () => {
                              try {
                                const { connectionRequestService } = await import('../services/connectionRequestService');
                                await connectionRequestService.handleKnownContactResponse(request.id, 'declined');
                                await handleConnectionRequest(request.id, 'decline');
                              } catch (error) {
                                console.error('Error declining:', error);
                                alert('Er ging iets mis bij het afwijzen.');
                              }
                            }}
                            className="flex-1 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm"
                          >
                            ✗ Afwijzen
                          </button>
                          <button
                            onClick={async () => {
                              try {
                                const { connectionRequestService } = await import('../services/connectionRequestService');
                                await connectionRequestService.handleKnownContactResponse(request.id, 'continue');
                                loadEssentialData();
                              } catch (error) {
                                console.error('Error continuing:', error);
                                alert('Er ging iets mis.');
                              }
                            }}
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm"
                          >
                            → Normale Flow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
            
            {incomingRequests.length === 0 && (
              <div className="text-center py-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Geen verzoeken</h3>
                <p className="text-gray-600">Je hebt nog geen connectie verzoeken ontvangen.</p>
              </div>
            )}
          </div>
        )}

        {activeTab === 'sent' && (
          <div className="space-y-4">
            {sentRequests.map(request => (
              <div key={request.id} className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm  transition-shadow">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-[#2E5F56] rounded-full flex items-center justify-center">
                      <span className="text-white font-semibold text-lg">📤</span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{request.toUserName}</h3>
                      <p className="text-sm text-gray-600">
                        {request.message || 'Connectie verzoek verzonden'}
                      </p>
                      <p className="text-xs text-gray-500">
                        {request.createdAt.toLocaleDateString('nl-NL')}
                      </p>
                    </div>
                  </div>
                  <span className="bg-[rgba(46,95,86,0.08)] text-[#4F6660] px-3 py-1 rounded-full text-sm font-medium">
                    Wachtend
                  </span>
                </div>
              </div>
            ))}
            
            {sentRequests.length === 0 && (
              <div className="text-center py-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Geen verzonden verzoeken</h3>
                <p className="text-gray-600">Je hebt nog geen connectie verzoeken verzonden.</p>
              </div>
            )}
          </div>
        )}
      </main>
      {/* end grid cols */}
      </div>
        </div>
      </div>

      {/* MOBILE LAYOUT — wired to App-level mobileTabIndex */}
      <div className="block md:hidden h-full min-h-0 overflow-hidden bg-[#F4F1EA]">

        {/* ── Tab 0: Mijn Netwerk ── */}
        {mobileTabIndex === 0 && (
          <div className="h-full min-h-0 overflow-y-auto px-4 pt-4 pb-4">
            <div className="mb-4">
              <OpenForConnectionsList
                settingsOnly
                onConnect={(userId, userName) => {
                  console.log(`Connectie verzoek naar ${userName} (${userId})`);
                  loadEssentialData();
                }}
              />
            </div>

            {/* Search */}
            <div className="relative mb-4">
              <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
              <input
                type="text"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Zoek een connectie…"
                className="w-full rounded-full border border-gray-200 bg-gray-50 py-2.5 pl-9 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-[#4F6660] focus:outline-none focus:ring-2 focus:ring-[#4F6660]/20"
              />
            </div>

            {/* Connections list */}
            {loading ? (
              <div className="divide-y divide-gray-100">
                {[1,2,3].map(i => (
                  <div key={i} className="flex items-center gap-3 py-3 animate-pulse">
                    <div className="h-11 w-11 rounded-full bg-gray-200 flex-shrink-0" />
                    <div className="flex-1 space-y-2">
                      <div className="h-3.5 w-32 rounded-full bg-gray-200" />
                      <div className="h-3 w-20 rounded-full bg-gray-100" />
                    </div>
                  </div>
                ))}
              </div>
            ) : connections.filter(c => {
              const name = c.user1Id === userProfile?.uid ? c.user2Name : c.user1Name;
              return !searchQuery || name.toLowerCase().includes(searchQuery.toLowerCase());
            }).length === 0 ? (
              <div className="flex min-h-[52vh] flex-col items-center justify-start px-6 pt-14 text-center">
                <Handshake size={34} weight="regular" className="mb-5 text-[#4F6660]/70" />
                <div className="text-lg font-semibold leading-tight text-[#2F3A36]">Nog geen connecties</div>
                <div className="mt-2 max-w-[260px] text-sm leading-relaxed text-[#8A8A84]">Ga naar Suggesties om mensen te vinden.</div>
              </div>
            ) : (
              <div className="divide-y divide-gray-100">
                {connections
                  .filter(c => {
                    const name = c.user1Id === userProfile?.uid ? c.user2Name : c.user1Name;
                    return !searchQuery || name.toLowerCase().includes(searchQuery.toLowerCase());
                  })
                  .sort((a, b) => (b.lastChatAt?.getTime() ?? b.createdAt.getTime()) - (a.lastChatAt?.getTime() ?? a.createdAt.getTime()))
                  .map(conn => {
                    const isUser1 = conn.user1Id === userProfile?.uid;
                    const otherName = isUser1 ? conn.user2Name : conn.user1Name;
                    const otherPhoto = isUser1 ? conn.user2Photo : conn.user1Photo;
                    return (
                      <div key={conn.id} className="flex items-center gap-3 py-3">
                        {otherPhoto ? (
                          <img src={otherPhoto} alt="" className="h-11 w-11 rounded-full object-cover flex-shrink-0" />
                        ) : (
                          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-[#8DA8A0] text-sm font-bold text-white">
                            {otherName.slice(0, 1).toUpperCase()}
                          </div>
                        )}
                        <div className="min-w-0 flex-1">
                          <div className="truncate text-sm font-semibold text-gray-800">{otherName}</div>
                          {conn.chatCount > 0 && (
                            <div className="text-[11px] text-gray-400">{conn.chatCount} berichten</div>
                          )}
                        </div>
                        <button
                          onClick={() => openChatWithConnection(conn)}
                          className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#F0F7F4] text-[#4F6660] hover:bg-[#4F6660] hover:text-white transition-colors"
                        >
                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
                        </button>
                      </div>
                    );
                  })
                }
              </div>
            )}
          </div>
        )}

        {/* ── Tab 1: Suggesties ── */}
        {mobileTabIndex === 1 && (
          <div className="h-full min-h-0 overflow-y-auto px-4 pt-4 pb-4">
            <p className="mb-3 text-[11px] text-[#8A8A84]">Mensen in jouw regio die open staan voor netwerken.</p>
            <OpenForConnectionsList
              minimal
              onConnect={(userId, userName) => {
                console.log(`Connectie verzoek naar ${userName} (${userId})`);
                loadEssentialData();
              }}
            />
          </div>
        )}

        {/* ── Tab 2: Verzoeken ── */}
        {mobileTabIndex === 2 && (
          <div className="h-full min-h-0 overflow-y-auto px-4 pt-4 pb-4">
            <p className="mb-3 text-[11px] leading-relaxed text-[#8A8A84]">
              Uitnodigingen van leden die met jou willen kennismaken.
            </p>
            {incomingRequests.filter(r => r.status === 'pending').length === 0 ? (
              <div className="flex min-h-[52vh] flex-col items-center justify-start px-6 pt-24 text-center">
                <ArchiveTray size={34} weight="regular" className="mb-5 text-[#4F6660]/70" />
                <div className="text-lg font-semibold leading-tight text-[#2F3A36]">Geen openstaande verzoeken</div>
                <div className="mt-2 max-w-[290px] text-sm leading-relaxed text-[#8A8A84]">
                  Verzoeken verschijnen wanneer iemand jou via Suggesties of jouw profiel een connectieverzoek stuurt.
                </div>
              </div>
            ) : (
              <div className="divide-y divide-gray-100">
                {incomingRequests
                  .filter(r => r.status === 'pending')
                  .map(request => (
                    <div key={request.id} className="py-4">
                      <div className="flex items-center gap-3 mb-3">
                        {request.fromUserPhoto ? (
                          <img src={request.fromUserPhoto} alt="" className="h-11 w-11 rounded-full object-cover flex-shrink-0" />
                        ) : (
                          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-[#8DA8A0] text-sm font-bold text-white">
                            {request.fromUserName.slice(0, 1).toUpperCase()}
                          </div>
                        )}
                        <div className="min-w-0 flex-1">
                          <div className="truncate text-sm font-semibold text-gray-800">{request.fromUserName}</div>
                          <div className="text-[11px] text-gray-400">
                            {new Date(request.createdAt).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' })}
                          </div>
                        </div>
                      </div>
                      {request.message && (
                        <p className="mb-3 rounded-xl bg-gray-50 px-3 py-2 text-xs leading-relaxed text-gray-600">"{request.message}"</p>
                      )}
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleConnectionRequest(request.id, 'accept')}
                          className="flex-1 rounded-full bg-[#4F6660] py-2 text-xs font-semibold text-white"
                        >
                          Accepteren
                        </button>
                        <button
                          onClick={() => handleConnectionRequest(request.id, 'decline')}
                          className="flex-1 rounded-full border border-gray-200 py-2 text-xs font-semibold text-gray-500"
                        >
                          Weigeren
                        </button>
                      </div>
                    </div>
                  ))
                }
              </div>
            )}
          </div>
        )}

        {/* ── Tab 3: ConnectieFlow ── */}
        {mobileTabIndex === 3 && (
          <div className="h-full min-h-0 overflow-y-auto">
            <ConnectieFlow />
          </div>
        )}

        {/* ── Tab 4: Chats ── */}
        {mobileTabIndex === 4 && (
          <div className="h-full min-h-0 overflow-y-auto">
            <ChatInterface />
          </div>
        )}
      </div>

      {/* Modals - Shared between mobile and desktop */}
      {/* Request Modal */}
      {showRequestModal && selectedMember && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Connectie verzoek naar {selectedMember.displayName}
            </h3>
            
            <textarea
              value={requestMessage}
              onChange={(e) => setRequestMessage(e.target.value)}
              placeholder="Schrijf een persoonlijk bericht (optioneel)..."
              className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
              rows={3}
            />
            
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="knownContactConnectiesPage2"
                checked={isKnownContact}
                onChange={(e) => setIsKnownContact(e.target.checked)}
                className="mr-2 h-4 w-4 text-[#7A9488] focus:ring-[#7A9488] border-gray-300 rounded accent-[#7A9488]"
              />
              <label htmlFor="knownContactConnectiesPage2" className="text-sm text-gray-700">
                👋 We kennen elkaar al
              </label>
            </div>
            
            <div className="flex space-x-3">
              <button
                onClick={() => sendConnectionRequest(selectedMember.uid)}
                disabled={sendingRequest}
                className={`flex-1 bg-[#2E5F56] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#265049] ${
                  sendingRequest ? 'opacity-70 cursor-not-allowed pointer-events-none' : ''
                }`}
              >
                {sendingRequest ? 'Versturen...' : 'Verzoek Versturen'}
              </button>
              <button
                onClick={() => {
                  setShowRequestModal(false);
                  setSelectedMember(null);
                  setRequestMessage('');
                  setIsKnownContact(false);
                }}
                className="flex-1 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg font-medium hover:bg-gray-300 "
              >
                Annuleren
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Clean Test Accounts bevestigingsmodal */}
      {showCleanConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl border border-red-200 max-w-lg w-full p-6">
            <div className="flex items-start gap-3">
              <div className="mt-1 flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600">
                <AlertTriangle size={20} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-1">
                  Zeker dat je <span className="text-red-600">ALLES</span> wilt wissen?
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Deze actie is bedoeld voor testomgevingen en kan niet ongedaan worden gemaakt.
                </p>
                <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1 mb-4">
                  <li>Alle <strong>connection requests</strong> worden verwijderd</li>
                  <li>Alle <strong>connections</strong> tussen accounts worden gewist</li>
                  <li>Alle <strong>chat rooms en berichten</strong> worden verwijderd</li>
                  <li>Alle <strong>connection flows</strong> en bijbehorende data verdwijnen</li>
                </ul>
                <p className="text-xs text-gray-500 mb-4">
                  Gebruik dit alleen als je het volledige netwerk tussen testaccounts opnieuw wilt opbouwen.
                </p>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowCleanConfirm(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                  >
                    Annuleren
                  </button>
                  <button
                    onClick={async () => {
                      setShowCleanConfirm(false);
                      await handleCleanAllConnections();
                    }}
                    className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 shadow-sm"
                  >
                    Ja, wis alles
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Invite Modal */}
      {inviteOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Nodig iemand uit</h3>

            {/* Template selector and CRUD */}
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Template</label>
              <div className="flex items-center gap-2">
                <select
                  value={selectedTemplateId}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSelectedTemplateId(val);
                    if (val === 'default') {
                      setTemplateName('Standaard');
                      setTemplateSubject(defaultInviteSubject);
                      setTemplateBody(buildDefaultInviteBody());
                    } else {
                      const tpl = inviteTemplates.find(t => t.id === val);
                      if (tpl) {
                        setTemplateName(tpl.name);
                        setTemplateSubject(tpl.subject);
                        setTemplateBody(tpl.body);
                      }
                    }
                  }}
                  className="flex-1 border rounded-lg px-3 py-2"
                >
                  <option value="default">Standaard</option>
                  {inviteTemplates.filter(t => t.id !== 'default').map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                <button
                  onClick={() => {
                    setSelectedTemplateId('new');
                    setTemplateName('Nieuw sjabloon');
                    setTemplateSubject(defaultInviteSubject);
                    setTemplateBody(buildDefaultInviteBody());
                  }}
                  className="text-sm px-2 py-1 rounded border"
                >Nieuw</button>
                <button
                  onClick={async () => {
                    try {
                      if (selectedTemplateId && selectedTemplateId !== 'default' && selectedTemplateId !== 'new') {
                        await updateDoc(doc(db, 'inviteTemplates', selectedTemplateId), {
                          name: templateName,
                          subject: templateSubject,
                          body: templateBody,
                          updatedAt: new Date()
                        });
                      } else {
                        const ref = await addDoc(collection(db, 'inviteTemplates'), {
                          ownerId: userProfile?.uid || null,
                          name: templateName,
                          subject: templateSubject,
                          body: templateBody,
                          createdAt: new Date()
                        });
                        setSelectedTemplateId(ref.id);
                      }
                      // refresh list
                      const tQ = query(collection(db, 'inviteTemplates'), where('ownerId', '==', userProfile?.uid || ''), orderBy('createdAt', 'desc'));
                      const tSnap = await getDocs(tQ);
                      const tpls = tSnap.docs.map(d => ({ id: d.id, name: (d.data() as any)?.name || 'Template', subject: (d.data() as any)?.subject || defaultInviteSubject, body: (d.data() as any)?.body || buildDefaultInviteBody() }));
                      setInviteTemplates([{ id: 'default', name: 'Standaard', subject: defaultInviteSubject, body: buildDefaultInviteBody() }, ...tpls]);
                    } catch (e) { console.error(e); }
                  }}
                  className="text-sm px-2 py-1 rounded border bg-blue-50 text-blue-700 border-blue-200"
                >Opslaan</button>
                <button
                  disabled={!selectedTemplateId || selectedTemplateId === 'default'}
                  onClick={async () => {
                    try {
                      if (selectedTemplateId && selectedTemplateId !== 'default') {
                        await deleteDoc(doc(db, 'inviteTemplates', selectedTemplateId));
                        setSelectedTemplateId('default');
                        setTemplateName('Standaard');
                        setTemplateSubject(defaultInviteSubject);
                        setTemplateBody(buildDefaultInviteBody());
                        // refresh
                        const tQ = query(collection(db, 'inviteTemplates'), where('ownerId', '==', userProfile?.uid || ''), orderBy('createdAt', 'desc'));
                        const tSnap = await getDocs(tQ);
                        const tpls = tSnap.docs.map(d => ({ id: d.id, name: (d.data() as any)?.name || 'Template', subject: (d.data() as any)?.subject || defaultInviteSubject, body: (d.data() as any)?.body || buildDefaultInviteBody() }));
                        setInviteTemplates([{ id: 'default', name: 'Standaard', subject: defaultInviteSubject, body: buildDefaultInviteBody() }, ...tpls]);
                      }
                    } catch (e) { console.error(e); }
                  }}
                  className={`text-sm px-2 py-1 rounded border ${(!selectedTemplateId || selectedTemplateId==='default') ? 'opacity-50 cursor-not-allowed' : ''}`}
                >Verwijderen</button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 mb-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Naam ontvanger</label>
                <input value={inviteRecipientName} onChange={(e) => setInviteRecipientName(e.target.value)} placeholder="Voornaam of volledige naam" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">E‑mailadres</label>
                <input type="email" placeholder="naam@bedrijf.com" value={inviteEmail} onChange={(e) => setInviteEmail(e.target.value)} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Onderwerp</label>
                <input value={templateSubject} onChange={(e) => setTemplateSubject(e.target.value)} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Bericht</label>
                <textarea rows={5} value={templateBody} onChange={(e) => setTemplateBody(e.target.value)} className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder={buildDefaultInviteBody()} />
                <p className="mt-1 text-xs text-gray-500">{'Gebruik placeholders: {{name}}, {{profile_signature}}'}</p>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2">
              <button onClick={() => setInviteOpen(false)} className="px-3 py-1.5 rounded bg-gray-100 hover:bg-gray-200">Annuleren</button>
              <button
                onClick={async () => {
                  try {
                    const displayName = (selfProfileDoc?.displayName || (userProfile as any)?.displayName || 'Gebruiker');
                    const role = (selfProfileDoc as any)?.role;
                    const company = (selfProfileDoc as any)?.company;
                    const email = (selfProfileDoc as any)?.email || (userProfile as any)?.email;
                    const phone = (selfProfileDoc as any)?.phone || (selfProfileDoc as any)?.phoneNumber || '';
                    const website = (selfProfileDoc as any)?.website || (selfProfileDoc as any)?.site || '';
                    const photoURL = (userProfile as any)?.photoURL || selfProfileDoc?.photoURL;
                    const profileUrl = (userProfile as any)?.uid ? `https://community.superkonnected.nl/#profile?u=${(userProfile as any)?.uid}` : '';
                    let signature = displayName;
                    if (role && company) signature += `\n${role} — ${company}`;
                    else if (company) signature += `\n${company}`;
                    else if (role) signature += `\n${role}`;
                    if (phone) signature += `\nTel: ${phone}`;
                    if (email) signature += `\n${email}`;
                    if (website) signature += `\n${website}`;
                    if (profileUrl) signature += `\nProfiel: ${profileUrl}`;
                    if (photoURL) signature += `\nProfielfoto: ${photoURL}`;

                    const finalBody = (templateBody || buildDefaultInviteBody())
                      .replace(/\{\{\s*name\s*\}\}/gi, inviteRecipientName || 'vriend')
                      .replace(/\{\{\s*profile_signature\s*\}\}/gi, signature);
                    const finalSubject = templateSubject || defaultInviteSubject;

                    await addDoc(collection(db, 'emailInvites'), {
                      email: inviteEmail,
                      templateId: selectedTemplateId,
                      subject: finalSubject,
                      body: finalBody,
                      invitedBy: (userProfile as any)?.uid || null,
                      invitedAt: new Date()
                    });

                    const body = encodeURIComponent(finalBody);
                    window.open(`mailto:${inviteEmail}?subject=${encodeURIComponent(finalSubject)}&body=${body}`, '_blank');
                  } catch (e) { console.error(e); }
                  setInviteOpen(false); setInviteEmail(''); setInviteRecipientName('');
                }}
                className="px-3 py-1.5 rounded bg-[#2E5F56] text-white hover:bg-[#265049]"
              >Versturen</button>
            </div>
          </div>
        </div>
      )}

      {/* Work Scope Settings Modal */}
      {showWorkScopeSettings && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Werkgebied Instellingen</h2>
                <button
                  onClick={() => setShowWorkScopeSettings(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ✕
                </button>
              </div>
            </div>
            
            <div className="p-6">
              <WorkScopeSettings 
                userProfile={userProfile}
                onUpdate={() => {
                  // Reload regional users when settings are updated
                  loadRegionalUsers();
                  setShowWorkScopeSettings(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
      {showRequestModal && selectedMember && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Connectie verzoek naar {selectedMember.displayName}
            </h3>
            
            <textarea
              value={requestMessage}
              onChange={(e) => setRequestMessage(e.target.value)}
              placeholder="Schrijf een persoonlijk bericht (optioneel)..."
              className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
              rows={3}
            />
            
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="knownContactConnectiesPage3"
                checked={isKnownContact}
                onChange={(e) => setIsKnownContact(e.target.checked)}
                className="mr-2 h-4 w-4 text-[#7A9488] focus:ring-[#7A9488] border-gray-300 rounded accent-[#7A9488]"
              />
              <label htmlFor="knownContactConnectiesPage3" className="text-sm text-gray-700">
                👋 We kennen elkaar al
              </label>
            </div>
            
            <div className="flex space-x-3">
              <button
                onClick={() => sendConnectionRequest(selectedMember.uid)}
                className="flex-1 bg-[#2E5F56] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#265049] "
              >
                Verzoek Versturen
              </button>
              <button
                onClick={() => {
                  setShowRequestModal(false);
                  setSelectedMember(null);
                  setRequestMessage('');
                  setIsKnownContact(false);
                }}
                className="flex-1 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg font-medium hover:bg-gray-300 "
              >
                Annuleren
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Clean Test Accounts bevestigingsmodal */}
      {showCleanConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl border border-red-200 max-w-lg w-full p-6">
            <div className="flex items-start gap-3">
              <div className="mt-1 flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600">
                <AlertTriangle size={20} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-1">
                  Zeker dat je <span className="text-red-600">ALLES</span> wilt wissen?
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  Deze actie is bedoeld voor testomgevingen en kan niet ongedaan worden gemaakt.
                </p>
                <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1 mb-4">
                  <li>Alle <strong>connection requests</strong> worden verwijderd</li>
                  <li>Alle <strong>connections</strong> tussen accounts worden gewist</li>
                  <li>Alle <strong>chat rooms en berichten</strong> worden verwijderd</li>
                  <li>Alle <strong>connection flows</strong> en bijbehorende data verdwijnen</li>
                </ul>
                <p className="text-xs text-gray-500 mb-4">
                  Gebruik dit alleen als je het volledige netwerk tussen testaccounts opnieuw wilt opbouwen.
                </p>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowCleanConfirm(false)}
                    className="px-4 py-2 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
                  >
                    Annuleren
                  </button>
                  <button
                    onClick={async () => {
                      setShowCleanConfirm(false);
                      await handleCleanAllConnections();
                    }}
                    className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 shadow-sm"
                  >
                    Ja, wis alles
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Invite Modal */}
      {inviteOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Nodig iemand uit</h3>

            {/* Template selector and CRUD */}
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Template</label>
              <div className="flex items-center gap-2">
                <select
                  value={selectedTemplateId}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSelectedTemplateId(val);
                    if (val === 'default') {
                      setTemplateName('Standaard');
                      setTemplateSubject(defaultInviteSubject);
                      setTemplateBody(buildDefaultInviteBody());
                    } else {
                      const tpl = inviteTemplates.find(t => t.id === val);
                      if (tpl) {
                        setTemplateName(tpl.name);
                        setTemplateSubject(tpl.subject);
                        setTemplateBody(tpl.body);
                      }
                    }
                  }}
                  className="flex-1 border rounded-lg px-3 py-2"
                >
                  <option value="default">Standaard</option>
                  {inviteTemplates.filter(t => t.id !== 'default').map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                <button
                  onClick={() => {
                    setSelectedTemplateId('new');
                    setTemplateName('Nieuw sjabloon');
                    setTemplateSubject(defaultInviteSubject);
                    setTemplateBody(buildDefaultInviteBody());
                  }}
                  className="text-sm px-2 py-1 rounded border"
                >Nieuw</button>
                <button
                  onClick={async () => {
                    try {
                      if (selectedTemplateId && selectedTemplateId !== 'default' && selectedTemplateId !== 'new') {
                        await updateDoc(doc(db, 'inviteTemplates', selectedTemplateId), {
                          name: templateName,
                          subject: templateSubject,
                          body: templateBody,
                          updatedAt: new Date()
                        });
                      } else {
                        const ref = await addDoc(collection(db, 'inviteTemplates'), {
                          ownerId: userProfile?.uid || null,
                          name: templateName,
                          subject: templateSubject,
                          body: templateBody,
                          createdAt: new Date()
                        });
                        setSelectedTemplateId(ref.id);
                      }
                      // refresh list
                      const tQ = query(collection(db, 'inviteTemplates'), where('ownerId', '==', userProfile?.uid || ''), orderBy('createdAt', 'desc'));
                      const tSnap = await getDocs(tQ);
                      const tpls = tSnap.docs.map(d => ({ id: d.id, name: (d.data() as any)?.name || 'Template', subject: (d.data() as any)?.subject || defaultInviteSubject, body: (d.data() as any)?.body || buildDefaultInviteBody() }));
                      setInviteTemplates([{ id: 'default', name: 'Standaard', subject: defaultInviteSubject, body: buildDefaultInviteBody() }, ...tpls]);
                    } catch (e) { console.error(e); }
                  }}
                  className="text-sm px-2 py-1 rounded border bg-blue-50 text-blue-700 border-blue-200"
                >Opslaan</button>
                <button
                  disabled={!selectedTemplateId || selectedTemplateId === 'default'}
                  onClick={async () => {
                    try {
                      if (selectedTemplateId && selectedTemplateId !== 'default') {
                        await deleteDoc(doc(db, 'inviteTemplates', selectedTemplateId));
                        setSelectedTemplateId('default');
                        setTemplateName('Standaard');
                        setTemplateSubject(defaultInviteSubject);
                        setTemplateBody(buildDefaultInviteBody());
                        // refresh
                        const tQ = query(collection(db, 'inviteTemplates'), where('ownerId', '==', userProfile?.uid || ''), orderBy('createdAt', 'desc'));
                        const tSnap = await getDocs(tQ);
                        const tpls = tSnap.docs.map(d => ({ id: d.id, name: (d.data() as any)?.name || 'Template', subject: (d.data() as any)?.subject || defaultInviteSubject, body: (d.data() as any)?.body || buildDefaultInviteBody() }));
                        setInviteTemplates([{ id: 'default', name: 'Standaard', subject: defaultInviteSubject, body: buildDefaultInviteBody() }, ...tpls]);
                      }
                    } catch (e) { console.error(e); }
                  }}
                  className={`text-sm px-2 py-1 rounded border ${(!selectedTemplateId || selectedTemplateId==='default') ? 'opacity-50 cursor-not-allowed' : ''}`}
                >Verwijderen</button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 mb-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Naam ontvanger</label>
                <input value={inviteRecipientName} onChange={(e) => setInviteRecipientName(e.target.value)} placeholder="Voornaam of volledige naam" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">E‑mailadres</label>
                <input type="email" placeholder="naam@bedrijf.com" value={inviteEmail} onChange={(e) => setInviteEmail(e.target.value)} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Onderwerp</label>
                <input value={templateSubject} onChange={(e) => setTemplateSubject(e.target.value)} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Bericht</label>
                <textarea rows={5} value={templateBody} onChange={(e) => setTemplateBody(e.target.value)} className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder={buildDefaultInviteBody()} />
                <p className="mt-1 text-xs text-gray-500">{'Gebruik placeholders: {{name}}, {{profile_signature}}'}</p>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2">
              <button onClick={() => setInviteOpen(false)} className="px-3 py-1.5 rounded bg-gray-100 hover:bg-gray-200">Annuleren</button>
              <button
                onClick={async () => {
                  try {
                    const displayName = (selfProfileDoc?.displayName || (userProfile as any)?.displayName || 'Gebruiker');
                    const role = (selfProfileDoc as any)?.role;
                    const company = (selfProfileDoc as any)?.company;
                    const email = (selfProfileDoc as any)?.email || (userProfile as any)?.email;
                    const phone = (selfProfileDoc as any)?.phone || (selfProfileDoc as any)?.phoneNumber || '';
                    const website = (selfProfileDoc as any)?.website || (selfProfileDoc as any)?.site || '';
                    const photoURL = (userProfile as any)?.photoURL || selfProfileDoc?.photoURL;
                    const profileUrl = (userProfile as any)?.uid ? `https://community.superkonnected.nl/#profile?u=${(userProfile as any)?.uid}` : '';
                    let signature = displayName;
                    if (role && company) signature += `\n${role} — ${company}`;
                    else if (company) signature += `\n${company}`;
                    else if (role) signature += `\n${role}`;
                    if (phone) signature += `\nTel: ${phone}`;
                    if (email) signature += `\n${email}`;
                    if (website) signature += `\n${website}`;
                    if (profileUrl) signature += `\nProfiel: ${profileUrl}`;
                    if (photoURL) signature += `\nProfielfoto: ${photoURL}`;

                    const finalBody = (templateBody || buildDefaultInviteBody())
                      .replace(/\{\{\s*name\s*\}\}/gi, inviteRecipientName || 'vriend')
                      .replace(/\{\{\s*profile_signature\s*\}\}/gi, signature);
                    const finalSubject = templateSubject || defaultInviteSubject;

                    await addDoc(collection(db, 'emailInvites'), {
                      email: inviteEmail,
                      templateId: selectedTemplateId,
                      subject: finalSubject,
                      body: finalBody,
                      invitedBy: (userProfile as any)?.uid || null,
                      invitedAt: new Date()
                    });

                    const body = encodeURIComponent(finalBody);
                    window.open(`mailto:${inviteEmail}?subject=${encodeURIComponent(finalSubject)}&body=${body}`, '_blank');
                  } catch (e) { console.error(e); }
                  setInviteOpen(false); setInviteEmail(''); setInviteRecipientName('');
                }}
                className="px-3 py-1.5 rounded bg-[#2E5F56] text-white hover:bg-[#265049]"
              >Versturen</button>
            </div>
          </div>
        </div>
      )}

      {/* Work Scope Settings Modal */}
      {showWorkScopeSettings && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Werkgebied Instellingen</h2>
                <button
                  onClick={() => setShowWorkScopeSettings(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ✕
                </button>
              </div>
            </div>
            
            <div className="p-6">
              <WorkScopeSettings 
                userProfile={userProfile}
                onUpdate={() => {
                  // Reload regional users when settings are updated
                  loadRegionalUsers();
                  setShowWorkScopeSettings(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConnectiesPage;


